import {TbPlaneArrival, TbPlaneDeparture, TbTruckDelivery,} from "react-icons/tb";
import {RiShipFill} from "react-icons/ri";
import React from 'react';


export const SurveyReport = ({
                                 claimForm,
                                 fechaHar,
                                 fechaPack,
                                 surveyDate,
                             }) => {
    let fullPalletsSurvey, palletsSurvey, averageSurvey, allPalletsDamage;
    let pallets = [];
    let fullPallets = [];
    let allPalletsTemp = [];
    let inspectionFruitPacketList = [];
    const inspectionFruit =
        claimForm.inspection?.inspectionReport?.inspectionFruit;
    if (claimForm.inspection?.inspectionReport?.inspectionFruit?.length > 0) {
        for (
            let j = 0;
            j < claimForm.inspection.inspectionReport.inspectionFruit.length;
            j++
        ) {
            //console.log(claimForm.inspection.inspectionReport.inspectionFruit[j])
            for (
                let i = 0;
                i <
                claimForm.inspection.inspectionReport.inspectionFruit[j]
                    .inspectionPackageTemperature.length;
                i++
            ) {
                const currentPackage =
                    claimForm.inspection.inspectionReport.inspectionFruit[j]
                        .inspectionPackageTemperature[i];

                //Encuentra si existe el pallet
                let pallet = pallets.find((p) => p.id === currentPackage.packageName);
                if (!pallet) {
                    pallet = {
                        id: currentPackage.packageName,
                        palletNumber: currentPackage.packageName,
                        top: "0",
                        middle: "0",
                        bottom: "0",
                        topPicture: "",
                        middlePicture: "",
                        bottomPicture: "",
                    };
                    pallets.push(pallet);
                }

                switch (currentPackage.positionId) {
                    case 0:
                        //Arriba Top
                        pallet.top = currentPackage.registerTemperature;
                        pallet.topPicture = currentPackage.imageTemperatureUrl || "";
                        break;
                    //middle
                    case 1:
                        pallet.middle = currentPackage.registerTemperature;
                        pallet.middlePicture = currentPackage.imageTemperatureUrl || "";
                        break;
                    case 2:
                        //bottom
                        pallet.bottom = currentPackage.registerTemperature;
                        pallet.bottomPicture = currentPackage.imageTemperatureUrl || "";
                        break;
                    default:
                        break;
                }
                // Se corrige con lo de arriba

                // switch (currentPackage.position) {
                //     case "Arriba":
                //     case "Top":
                //         pallet.top = currentPackage.registerTemperature;
                //         pallet.topPicture = currentPackage.imageTemperatureUrl || '';
                //         break;
                //     case "Middle":
                //     case "En medio":
                //         pallet.middle = currentPackage.registerTemperature;
                //         pallet.middlePicture = currentPackage.imageTemperatureUrl || '';
                //         break;
                //     case "Bottom":
                //     case "Abajo":
                //         pallet.bottom = currentPackage.registerTemperature;
                //         pallet.bottomPicture = currentPackage.imageTemperatureUrl || '';
                //         break;
                // }
            }
            fullPallets.push(pallets);
        }
        fullPalletsSurvey = fullPallets;
        //console.log(fullPalletsSurvey)
        for (let i = 0; i < fullPallets.length; i++) {
            let pallet = fullPallets[i];
            for (let j = 0; j < pallet.length; j++) {
                const obj = pallet[j];
                for (const key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        const element = obj[key];
                        if (/https:\/\/rsk/.test(element)) {
                            let position = key.slice(0, -7);
                            let nrPallet = obj.palletNumber;
                            allPalletsTemp.push({
                                photo: element,
                                position: position,
                                numberPallet: nrPallet,
                            });
                        }
                    }
                }
            }
        }
        //console.log(allPalletsTemp)
        const sumTop = pallets
            .reduce((a, b) => parseFloat(a) + parseFloat(b.top), 0)
            .toFixed(2);
        const sumMiddle = pallets
            .reduce((a, b) => parseFloat(a) + parseFloat(b.middle), 0)
            .toFixed(2);
        const sumBottom = pallets
            .reduce((a, b) => parseFloat(a) + parseFloat(b.bottom), 0)
            .toFixed(2);

        palletsSurvey = pallets;
        //console.log(sumTop, sumMiddle, sumBottom);
        //console.log(pallets)
        averageSurvey = {
            top: (sumTop / pallets.length).toFixed(2),
            middle: (sumMiddle / pallets.length).toFixed(2),
            bottom: (sumBottom / pallets.length).toFixed(2),
        };
    }

    //console.log(palletsSurvey)

    let boxesDamage = [];
    let objUniqueProblems = [];
    let allPalletsTable = [];
    let allPalletsTable2 = [];

    function addSurveyData(data) {
        if (allPalletsTable[data.problem]) {
            allPalletsTable[data.problem].push(data);
        } else {
            allPalletsTable[data.problem] = [data];
        }
    }

    for (
        let m = 0;
        m < claimForm.inspection?.inspectionReport?.inspectionFruit.length;
        m++
    ) {
        let currentFruit =
            claimForm.inspection?.inspectionReport?.inspectionFruit[m].fruitName;
        let allProblems = [];
        if (
            claimForm.inspection?.inspectionReport?.inspectionFruit[m]
                .inspectionPacket.length > 0
        ) {
            for (
                let i = 0;
                i <
                claimForm.inspection?.inspectionReport?.inspectionFruit[m]
                    .inspectionPacket.length;
                i++
            ) {
                let currentBox =
                    claimForm.inspection?.inspectionReport?.inspectionFruit[m]
                        .inspectionPacket[i];
                //console.log(currentBox)
                let sum = 0;
                let mainProblem = "";
                let problemInspection = [];

                let box = {
                    id: i,
                    total: sum,
                    totalSpecies: claimForm.inspection?.inspectionReport?.inspectionFruit[m].totalSpeciesToInspect,
                    fruit: currentFruit,
                    packetId: currentBox.id,
                    boxLabel: currentBox.packetLabelCode ||
                        currentBox.packageCode ||
                        String(currentBox.packetNumber),
                    variety: currentBox.fruitSpecies?.description || "No variety",
                    boxLocation: currentBox.packageZone,
                    boxLocationId: currentBox.packageZoneId,
                    mainProblem: "--",
                    sortProblem1: "--",
                    sortProblem2: "--",
                    sortProblem3: "--",
                    palletNumber: currentBox.packageCode,
                    generalComment: currentBox.generalComment,
                };
                for (let j = 0; j < currentBox.inspectionPacketProblem.length; j++) {
                    let currentProblem = currentBox.inspectionPacketProblem[j];
                    sum += currentProblem.quantity;
                    problemInspection.push({
                        problem: currentProblem.damageDescription,
                        quantity: currentProblem.quantity,
                        photo:
                            currentProblem.imageUrl ||
                            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png",
                        severity: currentProblem.severity?.description || "No severity",
                    });
                }
                //Encuentra el problema más grande
                let maxQuantity = 0;
                for (let j = 0; j < problemInspection.length; j++) {
                    if (problemInspection[j].quantity > maxQuantity) {
                        maxQuantity = problemInspection[j].quantity;
                        mainProblem = problemInspection[j].problem;
                    }
                }

                //Crea una copia de la matriz original
                let sortedProblems = problemInspection.slice();
                let n = sortedProblems.length;
                for (let j = 0; j < n - 1; j++) {
                    for (let k = 0; k < n - j - 1; k++) {
                        if (sortedProblems[k].quantity < sortedProblems[k + 1].quantity) {
                            // Intercambia los elementos k y k+1
                            let temp = sortedProblems[k];
                            sortedProblems[k] = sortedProblems[k + 1];
                            sortedProblems[k + 1] = temp;
                        }
                    }
                }
                // //Recorre la lista ordenada de mayor a menor y muestra cada problema
                // //console.log("Problemas ordenados de mayor a menor según la cantidad:");
                // for (let j = 0; j < n; j++) {
                //     //console.log(sortedProblems[j].problem + ": " + sortedProblems[j].quantity);
                // }
                //console.log('Que mas trae BOX?',box);
                box.mainProblem = mainProblem;
                box.sortProblem1 = sortedProblems[0]?.problem || "--";
                box.sortProblem2 = sortedProblems[1]?.problem || "--";
                box.sortProblem3 = sortedProblems[2]?.problem || "--";
                box.total = sum;
                box.problemInspection = problemInspection;
                let thisPalletProblems = problemInspection.map((e) => e.problem);
                allProblems.push(thisPalletProblems);
                boxesDamage.push(box);
                //console.log(box)
            }

            let flatAllProblems = allProblems.flat(1);
            let uniqueProblems = [...new Set(flatAllProblems)];

            // const objUniqueProblems = uniqueProblems.map(problem => ({problem}));
            for (let i = 0; i < uniqueProblems.length; i++) {
                objUniqueProblems.push({problem: uniqueProblems[i]});
            }

            //console.log(uniqueProblems);
            for (let i = 0; i < boxesDamage.length; i++) {
                for (let j = 0; j < boxesDamage[i].problemInspection.length; j++) {
                    //console.log(boxesDamage[i].problemInspection[j])
                    let palletTable = {};
                    let problemString = boxesDamage[i].problemInspection[j].problem;
                    palletTable.id = i;
                    palletTable.problem =
                        boxesDamage[i].problemInspection[j].problem
                            .charAt(0)
                            .toUpperCase() +
                        boxesDamage[i].problemInspection[j].problem.slice(1);
                    palletTable.percentage =
                        (boxesDamage[i].problemInspection[j].quantity * 100) /
                        boxesDamage[i].totalSpecies;
                    // objUniqueProblems.problemString.push(palletTable);
                    // PONER MAYUSCULA
                    allPalletsTable.push(palletTable);
                    //console.log(objUniqueProblems)
                }
            }
            const outputObj = {};

            for (let i = 0; i < allPalletsTable.length; i++) {
                const item = allPalletsTable[i];
                const key = item.problem;

                if (outputObj[key]) {
                    outputObj[key].push(item);
                } else {
                    outputObj[key] = [item];
                }
            }
            for (const outputObjElement in outputObj) {
                //console.log(outputObj[outputObjElement])
                let sum = 0;
                for (let i = 0; i < outputObj[outputObjElement].length; i++) {
                    sum += outputObj[outputObjElement][i].percentage;
                }
                if (sum === 0) {
                    delete outputObj[outputObjElement];
                }
            }
            allPalletsTable = outputObj;
        }
    }
    const columnasTabla = Object.keys(allPalletsTable);
    //console.log(allPalletsTable)

    let orden = [];
    const columnaTablaIterar = () => {
        const flatArray = Object.values(allPalletsTable).flatMap((array) => array);
        flatArray.sort((a, b) => a.id - b.id);
        //console.log(flatArray);

        let newObjects = [];

        //Llenar de ceros una fila de promedios, con la cantidad de danios que hay en la tabla.
        let totalAverageDamage = [];
        for (let j = 0; j < columnasTabla.length; j++) {
            totalAverageDamage.push({percentage: 0, counter: 0});
        }
        for (let i = 0; i < boxesDamage.length; i++) {
            for (let j = 0; j < columnasTabla.length; j++) {
                const problem = columnasTabla[j];
                const existingObject = flatArray.find(
                    (o) => o.id === i && o.problem === problem
                );
                if (
                    existingObject?.percentage !== 0 &&
                    existingObject?.percentage !== undefined
                ) {
                    totalAverageDamage[j].percentage += existingObject.percentage;
                    totalAverageDamage[j].counter += 1;
                }
                if (existingObject) {
                    newObjects.push(existingObject);
                } else {
                    newObjects.push({
                        id: i,
                        problem: problem,
                        percentage: 0,
                    });
                }
                //console.log(totalAverageDamage[j])
            }
        }
        for (let j = 0; j < columnasTabla.length; j++) {
            // Incluyendo 0
            totalAverageDamage[j].percentage =
                totalAverageDamage[j].percentage / boxesDamage.length;

            // Sin incluir 0
            // totalAverageDamage[j].percentage = totalAverageDamage[j].percentage/totalAverageDamage[j].counter;
        }
        newObjects.push(totalAverageDamage);

        //Dejar en un array de acuerdo a sus ID.
        const ids = [...new Set(newObjects.map((item) => item.id))];
        const objectArrayById = ids.map((id) =>
            newObjects.filter((item) => item.id === id)
        );

        // INTENTO DE SEPARARLO EN 2 ARRAYS, PERO NO SERA NECESARIO :D
        // //console.log(objectArrayById)
        // const firstHalfArray = [];
        // const secondHalfArray = [];
        // if (objectArrayById[0].length > 10){
        //     for (let j = 0; j < objectArrayById.length; j++) {
        //         for (let i = 0; i < objectArrayById[j].length / 2; i++) {
        //             firstHalfArray.push(objectArrayById[j][i]);
        //         }
        //         for (let i = objectArrayById.length / 2; i < objectArrayById.length; i++) {
        //             secondHalfArray.push(objectArrayById[j][i]);
        //         }
        //     }
        // }
        // //console.log(firstHalfArray);
        // //console.log(secondHalfArray);

        return objectArrayById;
    };
    const listoParalaTabla = columnaTablaIterar();

    //console.log(listoParalaTabla)
    //console.log(boxesDamage)
    allPalletsDamage = {boxes: boxesDamage};

    //console.log({fullPalletsSurvey}, {palletsSurvey}, {averageSurvey}, {allPalletsDamage})
    const allPalletsGraphic = () => {
        const renderedLabelsByPallet = new Map(); // Mapa para controlar duplicados por pallet

        return (
            <>
                {allPalletsDamage.boxes.map((item, idx) => {
                    let boxLocation = "";
                    switch (item.boxLocationId) {
                        case 0:
                            boxLocation = "Top area";
                            break;
                        case 1:
                            boxLocation = "Middle area";
                            break;
                        case 2:
                            boxLocation = "Low area";
                            break;
                        case 3:
                            boxLocation = "Unknown";
                            break;
                        default:
                            boxLocation = "Unknown";
                    }

                    // Inicializar un conjunto para controlar duplicados de etiquetas de Brix por pallet
                    if (!renderedLabelsByPallet.has(item.palletNumber)) {
                        renderedLabelsByPallet.set(item.palletNumber, new Set());
                    }
                    const renderedLabels = renderedLabelsByPallet.get(item.palletNumber);

                    return (
                        <>
                            <p key={idx} style={{ fontWeight: "900", borderTop: "1px solid #e1e1e1", borderBottom: "1px solid #e1e1e1", width: "fit-content", marginTop: "2rem" }}>
                                Pallet Number {item.palletNumber}
                            </p>
                            <div key={idx} style={{ display: "flex", justifyContent: "center", width: "100%", borderBottom: "2px solid #555" }}>
                                <div style={{ width: "30ch" }}>
                                    <div style={{ display: "flex", gap: "20px", flexDirection: "column", padding: "1rem 0" }}>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "350px", height: "2rem", fontWeight: "500" }}>
                                                Box Label
                                            </div>
                                            <div style={{ border: "1px solid #e1e1e1", width: "540px", height: "2rem", paddingLeft: ".5rem", lineHeight: "1.7rem" }}>
                                                {item.boxLabel}
                                            </div>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "350px", height: "2rem", fontWeight: "500" }}>
                                                Variety
                                            </div>
                                            <div style={{ border: "1px solid #e1e1e1", width: "540px", height: "2rem", paddingLeft: ".5rem", lineHeight: "1.7rem" }}>
                                                {item.variety}
                                            </div>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "350px", height: "2rem", fontWeight: "500" }}>
                                                Box Location
                                            </div>
                                            <div style={{ border: "1px solid #e1e1e1", width: "540px", height: "2rem", paddingLeft: ".5rem", lineHeight: "1.7rem" }}>
                                                {boxLocation}
                                            </div>
                                        </div>
                                        <div style={{ display: "flex" }}>
                                            <div style={{ width: "350px", height: "2rem", fontWeight: "500" }}>
                                                Main Problem
                                            </div>
                                            <div style={{ border: "1px solid #e1e1e1", width: "540px", height: "2rem", paddingLeft: ".5rem", color: "red", fontWeight: "600", lineHeight: "1.7rem" }}>
                                                {item.mainProblem}
                                            </div>
                                        </div>
                                        <p>
                                            {" "}
                                            {item.generalComment && (
                                                <span>
                                                <span style={{ fontWeight: "bold" }}>Comment:</span>{" "}
                                                    {item.generalComment}
                                            </span>
                                            )}
                                        </p>
                                    </div>
                                    <div style={{ display: "flex", flex: 1, flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "60rem", marginBottom: '5%' }}>
                                        <div style={{ display: "flex", flex: 0.6, justifyContent: "flex-start", width: "100%", fontWeight: "500" }}>
                                            Brix information
                                        </div>
                                        <div style={{ flex: 1, display: "flex", justifyContent: "flex-start", alignItems: "center", width: "100%", fontWeight: "500" }}>
                                            <table style={{ border: "3px solid #e1e1e1" }}>
                                                <React.Fragment key={idx}>
                                                    <tr style={{ backgroundColor: "#1c36af", color: "#FFFFFF" }}>
                                                        <th style={{ backgroundColor: "#1c36af", color: "white", padding: ".4rem 1rem", border: "3px solid #e1e1e1", textAlign: "center" }}>
                                                            BOX LABEL NUMBER
                                                        </th>
                                                        <th style={{ backgroundColor: "#1c36af", color: "white", padding: ".4rem 1rem", border: "3px solid #e1e1e1", textAlign: "center" }}>
                                                            {item.boxLabel}
                                                        </th>
                                                    </tr>
                                                    <tr style={{ border: "3px solid #e1e1e1" }}>
                                                        <td style={{ border: "3px solid #e1e1e1", padding: ".4rem 1rem", textAlign: "center", minWidth: "13ch" }}>
                                                            Brix
                                                        </td>
                                                        <td style={{ border: "3px solid #e1e1e1", padding: ".4rem 1rem", textAlign: "center", minWidth: "13ch" }}>
                                                            {(() => {
                                                                const values = getQuantityBrixByPacket({packetId: item.packetId, label: item.boxLabel,});
                                                                if (values.length === 0) return null;
                                                                return values.map((q, index) => (
                                                                    <span key={index}>{q}
                                                                        {index === values.length - 1 ? "" : ";"}
                                                                </span>
                                                                ));
                                                            })()}
                                                        </td>
                                                    </tr>
                                                </React.Fragment>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    );
                })}
            </>
        );
    };

// Función auxiliar para obtener los datos de Brix para cada etiqueta de caja
    function getQuantityBrixByPacket({ packetId, label }) {
        let packet;

        for (const fr of inspectionFruit ?? []) {
            packet = fr.inspectionPacket?.find(p => p.id === packetId);
            if (packet) break;
        }
        if (!packet && label) {
            for (const fr of inspectionFruit ?? []) {
                packet = fr.inspectionPacket?.find(p => p.packetLabelCode === label);
                if (packet) break;
            }
        }
        const photos = packet?.inspectionBrixPhotos ?? [];
        return photos.map(ph => ph.quantity).filter(q => q !== 0);
    }

// dountGraphic function remains unchanged
    const dountGraphic = (fruitInspectionTotalFruit, packetProblemInspection) => {
        return (
            <>
                {packetProblemInspection.map((item, idx) => {
                    let percentage = Math.round(
                        (item.quantity / fruitInspectionTotalFruit.totalSpecies) * 100
                    );
                    if (percentage === 0) {
                        return null;
                    }
                    return (
                        <div key={idx}>
                            <div
                                style={{
                                    height: "52px",
                                    position: "relative",
                                    width: "100%",
                                    overflow: "hidden",
                                }}
                            >
                                <div
                                    style={{
                                        width: "110px",
                                        height: "110px",
                                        borderRadius: "100%",
                                        zIndex: 1,
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        right: 0,
                                        margin: "auto",
                                        border: "35px solid ",
                                        borderColor: "#e1e1e1 #e1e1e1 #555 #555",
                                        transform: `rotate(calc(1deg * (-45 + ${percentage} * 1.8)))`,
                                    }}
                                ></div>
                            </div>
                            <div
                                style={{
                                    width: "150px",
                                    fontSize: ".8rem",
                                    height: ".5rem",
                                    fontWeight: "500",
                                    marginTop: -5,
                                    paddingBottom: 0,
                                    lineHeight: "0px",
                                }}
                            >
                                {percentage}%
                            </div>
                            <div
                                style={{
                                    width: "150px",
                                    height: "2rem",
                                    fontWeight: "500",
                                }}
                            >
                                {item.problem.charAt(0).toUpperCase() + item.problem.slice(1)}
                            </div>
                        </div>
                    );
                })}
            </>
        );
    };



    const lat = claimForm.latitude;
    const lng = claimForm.longitude;
    const center = `${lat},${lng}`;
    const zoom = 15;
    const mapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${center}&zoom=${zoom}&size=700x360&maptype=roadmap&markers=color:red|${center}&key=${process.env.REACT_APP_APIKEY_GOOGLE}`;
    //console.log(claimForm)
    const today = new Date(Date.now());
    let fechaHoy =
        today.getDate() + "." + (today.getMonth() + 1) + "." + today.getFullYear();
    const dateAwb = new Date(claimForm.blAwbDate);
    let fechaAwb = dateAwb.toDateString().split(" ");
    fechaAwb = fechaAwb[2] + " " + fechaAwb[1] + " " + fechaAwb[3];
    const {inspectionGeneral} = claimForm.inspection.inspectionReport;
    const {shippingCompany, consignee, other} = inspectionGeneral;
    let countPhotoDamage = 0;
    const dateDiffInDays = (a, b) => {
        // Text to date
        let date1 = new Date(a);
        let date2 = new Date(b);
        // To calculate the time difference of two dates
        let differenceInTime = date1.getTime() - date2.getTime();
        // To calculate the no. of days between two dates
        return differenceInTime / (1000 * 3600 * 24);
    };
    //console.log(surveyDate,fechaHar)
    const nohayImagen = (e) => {
        e.target.src =
            "https://www.ayuntamientodevalencia.es/contenidos/imagenes/imagen-no-disponible.jpg";
    };
    let allImages = [];

    //Brixs
    const packetLabels = [];
    inspectionFruit.map((itemFrt, indexFrt) => {
        if (Array.isArray(itemFrt.inspectionPacket)) {
            itemFrt.inspectionPacket.map((itemPkg, indexPkg) => {
                packetLabels.push(itemPkg.packetLabelCode);
            });
        }
    });

    function getQuantityBrix(label) {
        const itemPkg = inspectionFruit.find((itemFrt) =>
            itemFrt.inspectionPacket.find((pkg) => pkg.packetLabelCode === label)
        );
        const brixPhotos = itemPkg?.inspectionPacket.find(
            (pkg) => pkg.packetLabelCode === label
        )?.inspectionBrixPhotos || [];

        return brixPhotos.map((photo) => photo.quantity).filter((quantity) => quantity !== 0);
    }


    const takeImages = (obj, padre, abuelo, bisabuelo, frutaD1, frutaD2) => {
        for (const key in obj) {
            if (typeof obj[key] === "object" && obj[key] !== null) {
                takeImages(obj[key], obj, padre, abuelo, bisabuelo, frutaD1);
            }
            if (padre === undefined) {
                //console.log(padre)
            }
            if (obj.hasOwnProperty(key)) {
                const element = obj[key];
                if (/https:/.test(element)) {
                    let imageName = key.replace(/([A-Z])/g, " $1");
                    imageName = imageName.charAt(0).toUpperCase() + imageName.slice(1);

                    if (
                        imageName === "Image" ||
                        imageName === "Image Url" ||
                        imageName === "Url"
                    ) {
                        if (obj.description !== undefined) {
                            if (frutaD2.fruitName !== undefined) {
                                imageName = `${frutaD2.fruitName} ${obj.description} - (${bisabuelo.packageCode} - ${bisabuelo.packetLabelCode})`;
                            } else {
                                imageName = `${obj.description}`;
                            }
                        } else if (obj.damageDescription !== undefined) {
                            if (frutaD1.fruitName !== undefined) {
                                imageName = `${frutaD1.fruitName} ${obj.damageDescription} (${abuelo.packageCode} - ${abuelo.packetLabelCode})`;
                            } else {
                                imageName = `${obj.damageDescription}`;
                            }
                        }
                    }
                    if (imageName.includes("Url")) {
                        imageName = imageName.replace("Url", "");
                    }
                    if (imageName === "") {
                        imageName = `Brix (${abuelo.packageCode} - ${abuelo.packetLabelCode})`;
                    }
                    if (imageName === "Image Temperature ") {
                        imageName = `Temperature - Package ${obj.packageName} `;
                        // imageName = `Package ${obj.packageName} - ${obj.position} Temperature`;
                    }
                    if (imageName.trim() === "Fruit Condition") {
                        imageName = `Fruit Condition (${obj.packageCode} - ${obj.packetLabelCode}) `;
                    }

                    imageName.trim();
                    if (element.includes("DAMAGE")) {
                        //console.log(element)
                    } else {
                        allImages.push({
                            name: imageName,
                            image: element,
                        });
                    }
                }
            }
        }
    };
    const additionalDescription = [];
    for (
        let i = 0;
        i < claimForm.inspection.inspectionReport?.inspectionFruit.length;
        i++
    ) {
        if (
            claimForm.inspection.inspectionReport?.inspectionFruit[i]
                .additionalDescription !== null &&
            claimForm.inspection.inspectionReport?.inspectionFruit[i]
                .additionalDescription !== ""
        ) {
            additionalDescription.push(
                `${claimForm.inspection.inspectionReport?.inspectionFruit[i].fruitName} - ${claimForm.inspection.inspectionReport?.inspectionFruit[i].additionalDescription}`
            );
        }
    }
    //console.log(additionalDescription)
    return (
        <>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                }}
            >
                <div style={{marginBottom: "5px", marginLeft: "1rem"}}>
                    <div style={{display: "flex"}}>
                        <div
                            style={{
                                width: ".9rem",
                                background: "#1c36af",
                                marginBottom: "1rem",
                            }}
                        ></div>
                        <div style={{paddingLeft: ".5rem"}}>
                            <div
                                style={{
                                    fontFamily: "'Roboto Condensed', sans-serif",
                                    marginBottom: "3px",
                                    fontSize: "2.4rem",
                                    fontWeight: 700,
                                    paddingTop: ".5rem",
                                }}
                            >
                                SURVEY REPORT
                            </div>
                            <div
                                style={{
                                    marginTop: "2px",
                                    fontFamily: "'Golos Text', sans-serif",
                                    fontSize: ".8rem",
                                }}
                            >
                                RSK. REF N° <span>{claimForm.createdTime.slice(0, 4)}</span>/
                                <span>{claimForm.id}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{marginBottom: "5px"}}>
                    <div
                        style={{
                            textAlign: "right",
                            fontFamily: "'Golos Text', sans-serif",
                            fontSize: "1rem",
                        }}
                    >
                        {claimForm.surveyor.firstName} {claimForm.surveyor.lastName}
                    </div>
                    {claimForm.surveyor.companySurveyorName && (
                        <div
                            style={{
                                fontFamily: "'Golos Text', sans-serif",
                                fontSize: "1rem",
                                fontWeight: "600",
                                textAlign: "right",
                            }}
                        >
                            {claimForm.surveyor.companySurveyorName}
                        </div>
                    )}
                </div>
            </div>
            <div style={{position: "relative"}}>
                <div
                    style={{
                        backgroundColor: "#1c36af",
                        height: "1rem",
                        width: "1rem",
                        position: "absolute",
                        marginTop: "-.5rem",
                        borderRadius: "50%",
                    }}
                ></div>
                <div
                    style={{
                        backgroundColor: "#1c36af",
                        height: "2px",
                        width: "100%",
                        margin: "auto",
                    }}
                ></div>
            </div>
            <p style={{marginTop: "1rem"}}>{claimForm.surveyor.mainAddress}</p>

            <div style={{height: "10px"}}></div>
            <b style={{color: "#4371d6"}}>GENERAL INFORMATION</b>
            <div style={{height: "20px"}}></div>

            <div style={{display: "block", marginLeft: "3rem"}}>
                <div style={{width: "5%", display: "inline-block"}}></div>
                <div
                    style={{
                        display: "inline-block",
                        width: "40%",
                        verticalAlign: "top",
                    }}
                >
                    {claimForm.transportId === 1 ? (
                        <p>
                            Exporter: <span>{claimForm.exporterName}</span>
                        </p>
                    ) : claimForm.transportId === 2 ? (
                        <p>
                            Shipper:{" "}
                            <span>
                {claimForm.shipperName ? claimForm.shipperName : "----"}
              </span>
                        </p>
                    ) : (
                        <p>
                            Shipper:{" "}
                            <span>
                {claimForm.carrierName ? claimForm.carrierName : "----"}
              </span>
                        </p>
                    )}

                    <p>
                        Consignee: <span>{claimForm.consigneeName}</span>
                    </p>
                    {claimForm.transportId === 1 && (
                        <p>
                            Carrier: <span>{claimForm.carrierName}</span>
                        </p>
                    )}

                    {claimForm.transportId === 1 ? (
                        <p>
                            {" "}
                            Vessel: <span>{claimForm.vessel}</span>
                        </p>
                    ) : claimForm.transportId === 2 ? (
                        <p>
                            Airline/Carrier: <span>{claimForm.carrierName}</span>
                        </p>
                    ) : (
                        <p>
                            Airline/Carrier:{" "}
                            <span>
                {claimForm.carrierName ? claimForm.carrierName : "----"}
              </span>
                        </p>
                    )}
                </div>
                <div
                    style={{
                        display: "inline-block",
                        width: "40%",
                        verticalAlign: "top",
                    }}
                >
                    {claimForm.transportId !== 2 && (
                        <p>
                            <span>Container:</span>
                            <span>
                {claimForm.cargo?.containerNumber
                    ? `${claimForm.cargo?.containerNumber}`
                    : "---"}
              </span>
                        </p>
                    )}
                    <p>
                        {claimForm.transportId === 1 ? "POL:" : "Departure Location: "}{" "}
                        <span>{claimForm.pol}</span>
                    </p>
                    <p>
                        {claimForm.transportId === 1 ? "POD:" : "Arrival Location: "}{" "}
                        <span>{claimForm.pod}</span>
                    </p>
                </div>
            </div>

            <div style={{height: "30px"}}></div>
            <b style={{color: "#4371d6"}}>INTRODUCTION</b>
            <div style={{height: "20px"}}></div>

            <p>
                On <span>{fechaHoy}</span>, <span>{claimForm.exporterName}</span>,
                requested our services in order to carry out the inspection to the
                following cargo details:
            </p>

            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "2rem",
                }}
            >
                <table style={{border: "3px solid #e1e1e1"}}>
                    <tr style={{backgroundColor: "#1c36af", color: "white"}}>
                        <th
                            style={{
                                backgroundColor: "#1c36af",
                                color: "white",
                                padding: ".4rem 1rem",
                                border: "3px solid #e1e1e1",
                                textAlign: "center",
                            }}
                        >
                            SPECIE
                        </th>
                        <th
                            style={{
                                backgroundColor: "#1c36af",
                                color: "white",
                                padding: ".4rem 1rem",
                                border: "3px solid #e1e1e1",
                                textAlign: "center",
                            }}
                        >
                            VARIETY
                        </th>
                        <th
                            style={{
                                backgroundColor: "#1c36af",
                                color: "white",
                                padding: ".4rem 1rem",
                                border: "3px solid #e1e1e1",
                                textAlign: "center",
                            }}
                        >
                            QUANTITY
                        </th>
                    </tr>

                    {claimForm.cargo.fruits.length > 0 &&
                        claimForm.cargo.fruits.map((fruit, index) => {
                            return (
                                <tr key={index} style={{border: "3px solid #e1e1e1"}}>
                                    <td
                                        style={{
                                            border: "3px solid #e1e1e1",
                                            padding: ".4rem 1rem",
                                            textAlign: "center",
                                            minWidth: "13ch",
                                        }}
                                    >
                                        {fruit.name}
                                    </td>
                                    <td
                                        style={{
                                            border: "3px solid #e1e1e1",
                                            padding: ".4rem 1rem",
                                            textAlign: "center",
                                            minWidth: "13ch",
                                        }}
                                    >
                                        {allPalletsDamage.boxes.map((item, idx) => {
                                            if (item.fruit === fruit.name) {
                                                return (
                                                    (idx !== allPalletsDamage.boxes.length - 1 &&
                                                        allPalletsDamage.boxes[idx].fruit ===
                                                        allPalletsDamage.boxes[idx + 1].fruit &&
                                                        item.variety + " - ") ||
                                                    item.variety
                                                );
                                            }
                                        })}
                                    </td>
                                    <td
                                        style={{
                                            border: "3px solid #e1e1e1",
                                            padding: ".4rem 1rem",
                                            textAlign: "center",
                                            minWidth: "13ch",
                                        }}
                                    >
                                        {fruit.boxes}
                                    </td>
                                </tr>
                            );
                        })}
                </table>
            </div>
            <div style={{height: "50px"}}></div>
            <b style={{color: "#4371d6"}}>COMPLAINT</b>
            <div style={{height: "20px"}}></div>
            <p>
                It was alleged by {claimForm.exporterName}, that as result of{" "}
                {claimForm.cargo.damages.map((damage, idx) =>
                    idx ? " - " + damage.description : damage.description
                )}{" "}
                cargo arrived in a damaged condition.
            </p>
            <p>
                The consignment consisted of
                {claimForm.cargo.fruits.length > 0 &&
                    claimForm.cargo.fruits.map((fruit, index) => {
                        //console.log(fruit)
                        return (
                            <span key={index}>
                {" "}
                                {index ? " - " : ""} {fruit.boxes} boxes of {fruit.name}
              </span>
                        );
                    })}
                {/*{claimForm.inspection.claim.inspectionReport.inspectionFruit.modality})*/}
                {/*containing ??(nombre del producto/especie)</p>*/}
            </p>

            <p>
                {" "}
                The survey was done at the premises of{" "}
                <span>
          {claimForm.inspection.inspectionReport.inspectionGeneral.address}
        </span>
                , located at{" "}
                {claimForm.inspection.claim?.inspectionAddress ??
                    claimForm.inspectionAddress}{" "}
                on {claimForm.inspection.inspectionDate}.
            </p>
            <br/>
            <div style={{textAlign: "center"}}>
                <img src={mapUrl} alt="mapImage" style={{margin: "auto"}}/>
            </div>
            <br/>
            <b style={{color: "#4371d6"}}>PARTIES INVOLVED</b>
            <div style={{height: "20px"}}></div>
            <p>
                The inspection was held{" "}
                {shippingCompany || consignee || other ? "with" : "without"} the
                presence of the following persons/any other invited party.
                {/*<div style={{height:'10px'}}></div>*/}
            </p>
            <p>
                {shippingCompany || consignee || other
                    ? " The following persons were present:"
                    : " No one was present."}
            </p>
            <p>
                {/*<div style={{height:'10px'}}></div>*/}
                <div style={{display: "flex", justifyContent: "space-between"}}>
                    <div>
                        {shippingCompany && <p>Shipping Company: {shippingCompany}</p>}
                        {consignee && <p>Consignee: {consignee}</p>}
                        {other && <p>Other: {other}</p>}
                    </div>
                </div>
                Notice of claim was sent on {claimForm.documents.noticeDate}.
            </p>
            <p>
                The following report will show the nature, extent, and circumstances of
                the damage.
            </p>
            <div style={{height: "30px"}}></div>
            <b style={{color: "#4371d6"}}>SURVEY FINDINGS</b>
            <div style={{height: "10px"}}></div>
            {claimForm.transportId !== 2 &&
                claimForm.inspection.inspectionReport.inspectionFruit.length !== 0 && (
                    <div style={{marginTop: "1rem"}}>
                        <b>CONDITION OF THE CONTAINER</b>
                        <p style={{marginTop: ".8rem"}}>
                            {!claimForm.inspection.inspectionReport.inspectionContainerDetails
                                    .isContainerAvailable &&
                                "The container was no longer on site, so we were unable to check the condition of the reefer unit," +
                                " including its settings and the stowage of the pallets inside the container."}
                            {/*<span style={{backgroundColor:'orange'}}>isFruitInsideOfContainer y isCargoAvailable con null?</span>*/}

                            {/*<br/>*/}
                            {claimForm.inspection.inspectionReport.inspectionContainerDetails
                                .isContainerAvailable && (
                                <div style={{marginTop: "1rem"}}>
                                    The following information was observed:
                                </div>
                            )}
                            {claimForm.inspection.inspectionReport.inspectionContainerDetails
                                .isContainerAvailable && (
                                <div
                                    style={{
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: "2rem 0",
                                        gap: "250px",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "inline-block",
                                            width: "35%",
                                            verticalAlign: "top",
                                        }}
                                    >
                                        <p style={{textAlign: "center", fontWeight: "bold"}}>
                                            Carriage Instruction
                                        </p>

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                padding: ".6rem 0",
                                            }}
                                        >
                                            <span>Temperature:</span>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "20ch",
                                                    gap: ".5rem",
                                                }}
                                            >
                        <span
                            style={{
                                border: "1px solid #666",
                                padding: ".2rem",
                                width: "10ch",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                            }}
                        >
                          {claimForm.cargo.temperature !== ""
                              ? `${claimForm.cargo.temperature}`
                              : "---"}{" "}
                            °C
                        </span>
                                                <span
                                                    style={{padding: ".2rem", width: "10ch"}}
                                                ></span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                padding: ".6rem 0",
                                            }}
                                        >
                                            <span>Ventilation:</span>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "20ch",
                                                    gap: ".5rem",
                                                }}
                                            >
                        <span
                            style={{
                                border: "1px solid #666",
                                padding: ".2rem",
                                width: "10ch",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                            }}
                        >
                          {claimForm.cargo.ventilation !== ""
                              ? `${claimForm.cargo.ventilation}`
                              : "---"}{" "}
                            CBM
                        </span>
                                                <span
                                                    style={{padding: ".2rem", width: "10ch"}}
                                                ></span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                padding: ".6rem 0",
                                            }}
                                        >
                                            <span>Controlled Atmosphere</span>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    width: "20ch",
                                                    gap: ".5rem",
                                                }}
                                            >
                        <span
                            style={{
                                border: "1px solid #666",
                                padding: ".2rem",
                                width: "10ch",
                                whiteSpace: "nowrap",
                                textAlign: "center",
                            }}
                        >
                          {claimForm.cargo.co2 !== "" &&
                          claimForm.cargo.co2 !== null
                              ? `${claimForm.cargo.co2}`
                              : "---"}{" "}
                            CO2
                        </span>
                                                <span
                                                    style={{
                                                        border: "1px solid #666",
                                                        padding: ".2rem",
                                                        width: "10ch",
                                                        whiteSpace: "nowrap",
                                                        textAlign: "center",
                                                    }}
                                                >
                          {claimForm.cargo.o2 !== "" &&
                          claimForm.cargo.o2 !== null
                              ? `${claimForm.cargo.o2}`
                              : "---"}{" "}
                                                    O2
                        </span>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div style={{display: "inline-block", width: "35%", verticalAlign: "top" }}>*/}
                                    {/*    <p style={{textAlign:'center', fontWeight:'bold'}}>Arrival Condition</p>*/}
                                    {/*    <p style={{display:'flex', justifyContent:'space-between'}}>*/}
                                    {/*        <span>Temperature:</span>*/}
                                    {/*        <div style={{ display:'flex',justifyContent:'space-between',width:'20ch', gap:'.5rem'}}>*/}
                                    {/*            <span style={{border:'1px solid #666', padding:'.2rem', width:'10ch', whiteSpace:'nowrap', textAlign:'center'}}>{claimForm.cargo.temperature !== "" ? `${claimForm.cargo.temperature}` : '---'} °C</span>*/}
                                    {/*            <span style={{ padding:'.2rem', width:'10ch'}}></span>*/}
                                    {/*        </div>*/}
                                    {/*    </p>*/}
                                    {/*    <p style={{display:'flex', justifyContent:'space-between'}}>*/}
                                    {/*        <span>Ventilation:</span>*/}
                                    {/*        <div style={{ display:'flex',justifyContent:'space-between',width:'20ch', gap:'.5rem'}}>*/}
                                    {/*            <span style={{border:'1px solid #666', padding:'.2rem', width:'10ch', whiteSpace:'nowrap', textAlign:'center'}}>{claimForm.cargo.ventilation !== "" ? `${claimForm.cargo.ventilation}` : '---'} CBM</span>*/}
                                    {/*            <span style={{padding:'.2rem', width:'10ch'}}></span>*/}
                                    {/*        </div>*/}
                                    {/*    </p>*/}
                                    {/*    <p style={{display:'flex', justifyContent:'space-between'}}>*/}
                                    {/*        <span>Controlled Atmosphere</span>*/}
                                    {/*        <div style={{ display:'flex',justifyContent:'space-between',width:'20ch', gap:'.5rem'}}>*/}
                                    {/*            <span style={{border:'1px solid #666', padding:'.2rem', width:'10ch', whiteSpace:'nowrap', textAlign:'center'}}>{claimForm.cargo.CO2 !== "" && claimForm.cargo.CO2 !== undefined ? `${claimForm.cargo.CO2}` : '---'} CO2</span>*/}
                                    {/*            <span style={{border:'1px solid #666', padding:'.2rem', width:'10ch', whiteSpace:'nowrap', textAlign:'center'}}>{claimForm.cargo.O2 !== "" && claimForm.cargo.O2 !== undefined ? `${claimForm.cargo.O2}` : '---'} O2</span>*/}
                                    {/*        </div>*/}
                                    {/*    </p>*/}
                                    {/*</div>*/}
                                </div>
                            )}
                        </p>
                    </div>
                )}
            {claimForm.inspection.inspectionReport.inspectionFruit.length == 0 &&
                claimForm.inspection.inspectionReport.inspectionContainerDetails
                    .isOldContainerAvailable && (
                    <div style={{marginTop: "3rem"}}>
                        <b>CONDITION OF THE OLD CONTAINER</b>
                        <p style={{marginTop: ".8rem"}}>
                            {!claimForm.inspection.inspectionReport.inspectionContainerDetails
                                    .isOldContainerAvailable &&
                                "The container was no longer on site, so we were unable to check the condition of the reefer unit," +
                                " including its settings and the stowage of the pallets inside the container."}
                            {/*<span style={{backgroundColor:'orange'}}>isFruitInsideOfContainer y isCargoAvailable con null?</span>*/}
                            <div
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "space-around",
                                    margin: "2rem 0",
                                    gap: "25px",
                                }}
                            >
                                {claimForm.inspection.inspectionReport
                                    .inspectionContainerDetails.temperatureSetting !== "" && (
                                    <div style={{height: "500px", width: "33%"}}>
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport
                                                    .inspectionContainerDetails.temperatureSetting
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport
                                                        .inspectionContainerDetails.temperatureSetting !==
                                                    ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionContainerDetails.temperatureSetting
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="Temperature setting"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError={nohayImagen}
                                            />
                                        </a>
                                        <p style={{textAlign: "center"}}>Temperature setting</p>
                                    </div>
                                )}
                                {claimForm.inspection.inspectionReport
                                    .inspectionContainerDetails.ventilation !== "" && (
                                    <div style={{height: "500px", width: "33%"}}>
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport
                                                    .inspectionContainerDetails.ventilation
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport
                                                        .inspectionContainerDetails.ventilation !== ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionContainerDetails.ventilation
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="ventilacion"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                            />
                                        </a>
                                        <p style={{textAlign: "center"}}>Ventilation</p>
                                    </div>
                                )}
                                {claimForm.inspection.inspectionReport
                                    .inspectionContainerDetails.containerNumber !== "" && (
                                    <div style={{height: "500px", width: "33%"}}>
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport
                                                    .inspectionContainerDetails.containerNumber
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport
                                                        .inspectionContainerDetails.containerNumber !== ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionContainerDetails.containerNumber
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="Estado General"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                            />
                                        </a>
                                        <p style={{textAlign: "center"}}>Container Number</p>
                                    </div>
                                )}
                            </div>
                            {/*<br/>*/}
                        </p>
                        {claimForm.transportId !== 2 &&
                            claimForm.inspection.inspectionReport.inspectionContainerDetails
                                .commentOldContainer && (
                                <p>
                                    We observed that:{" "}
                                    {
                                        claimForm.inspection.inspectionReport
                                            .inspectionContainerDetails.commentOldContainer
                                    }
                                </p>
                            )}
                    </div>
                )}
            {claimForm.inspection.inspectionReport.inspectionFruit.length == 0 &&
                claimForm.inspection.inspectionReport.inspectionContainerDetails
                    .isNewContainerAvailable && (
                    <div style={{marginTop: "5rem"}}>
                        <b>CONDITION OF THE NEW CONTAINER</b>
                        <p style={{marginTop: ".8rem"}}>
                            {!claimForm.inspection.inspectionReport.inspectionContainerDetails
                                    .isNewContainerAvailable &&
                                "The container was no longer on site, so we were unable to check the condition of the reefer unit," +
                                " including its settings and the stowage of the pallets inside the container."}
                            {/*<span style={{backgroundColor:'orange'}}>isFruitInsideOfContainer y isCargoAvailable con null?</span>*/}
                            <div
                                style={{
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "space-around",
                                    margin: "2rem 0",
                                    gap: "25px",
                                }}
                            >
                                {claimForm.inspection.inspectionReport
                                    .inspectionContainerDetails.transferContext !== "" && (
                                    <div style={{height: "500px", width: "33%"}}>
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport
                                                    .inspectionContainerDetails.transferContext
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport
                                                        .inspectionContainerDetails.transferContext !== ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionContainerDetails.temperatureSetting
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="Temperature setting"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError={nohayImagen}
                                            />
                                        </a>
                                        <p style={{textAlign: "center"}}>
                                            Conditions/context of the transfer
                                        </p>
                                    </div>
                                )}
                                {claimForm.inspection.inspectionReport
                                    .inspectionContainerDetails.desConsolidation !== "" && (
                                    <div style={{height: "500px", width: "33%"}}>
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport
                                                    .inspectionContainerDetails.desConsolidation
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport
                                                        .inspectionContainerDetails.desConsolidation !== ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionContainerDetails.desConsolidation
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="ventilacion"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                            />
                                        </a>
                                        <p style={{textAlign: "center"}}>
                                            Deconsolidation of the container
                                        </p>
                                    </div>
                                )}
                                {claimForm.inspection.inspectionReport
                                    .inspectionContainerDetails.connectionToPlug !== "" && (
                                    <div style={{height: "500px", width: "33%"}}>
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport
                                                    .inspectionContainerDetails.connectionToPlug
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport
                                                        .inspectionContainerDetails.connectionToPlug !== ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionContainerDetails.connectionToPlug
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="Estado General"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                            />
                                        </a>
                                        <p style={{textAlign: "center"}}>
                                            Container connected to the plug
                                        </p>
                                    </div>
                                )}
                            </div>
                            {/*<br/>*/}
                        </p>
                        {claimForm.transportId !== 2 &&
                            claimForm.inspection.inspectionReport.inspectionContainerDetails
                                .commentNewContainer && (
                                <p>
                                    We observed that:{" "}
                                    {
                                        claimForm.inspection.inspectionReport
                                            .inspectionContainerDetails.isNewContainerAvailable
                                    }
                                </p>
                            )}
                    </div>
                )}
            {claimForm.inspection.inspectionReport.inspectionContainerDetails
                .isContainerAvailable && (
                <div
                    style={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "space-around",
                        margin: "2rem 0",
                        gap: "25px",
                    }}
                >
                    {claimForm.inspection.inspectionReport.inspectionContainerDetails
                        .temperatureSetting !== "" && (
                        <div style={{height: "500px", width: "33%"}}>
                            <a
                                href={
                                    claimForm.inspection.inspectionReport
                                        .inspectionContainerDetails.temperatureSetting
                                }
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={
                                        claimForm.inspection.inspectionReport
                                            .inspectionContainerDetails.temperatureSetting !== ""
                                            ? claimForm.inspection.inspectionReport
                                                .inspectionContainerDetails.temperatureSetting
                                            : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                    }
                                    alt="Temperature setting"
                                    style={{
                                        border: "1px solid black",
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "cover",
                                        borderRadius: "3px",
                                    }}
                                    className="hover-img"
                                    onMouseOver={(e) => {
                                        e.target.style.cursor = "pointer";
                                        e.target.style.opacity = "0.8";
                                        e.target.style.boxShadow = "0px 0px 2px 0 rgba(0,0,0,1)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.boxShadow = "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                    }}
                                    onError={nohayImagen}
                                />
                            </a>
                            <p style={{textAlign: "center"}}>Temperature setting</p>
                        </div>
                    )}
                    {claimForm.inspection.inspectionReport.inspectionContainerDetails
                        .ventilation !== "" && (
                        <div style={{height: "500px", width: "33%"}}>
                            <a
                                href={
                                    claimForm.inspection.inspectionReport
                                        .inspectionContainerDetails.ventilation
                                }
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={
                                        claimForm.inspection.inspectionReport
                                            .inspectionContainerDetails.ventilation !== ""
                                            ? claimForm.inspection.inspectionReport
                                                .inspectionContainerDetails.ventilation
                                            : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                    }
                                    alt="ventilacion"
                                    style={{
                                        border: "1px solid black",
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "cover",
                                        borderRadius: "3px",
                                    }}
                                    className="hover-img"
                                    onMouseOver={(e) => {
                                        e.target.style.cursor = "pointer";
                                        e.target.style.opacity = "0.8";
                                        e.target.style.boxShadow = "0px 0px 2px 0 rgba(0,0,0,1)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.boxShadow = "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                    }}
                                    onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                />
                            </a>
                            <p style={{textAlign: "center"}}>Ventilation</p>
                        </div>
                    )}
                    {claimForm.inspection.inspectionReport.inspectionContainerDetails
                        .containerNumber !== "" && (
                        <div style={{height: "500px", width: "33%"}}>
                            <a
                                href={
                                    claimForm.inspection.inspectionReport
                                        .inspectionContainerDetails.containerNumber
                                }
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img
                                    src={
                                        claimForm.inspection.inspectionReport
                                            .inspectionContainerDetails.containerNumber !== ""
                                            ? claimForm.inspection.inspectionReport
                                                .inspectionContainerDetails.containerNumber
                                            : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                    }
                                    alt="Estado General"
                                    style={{
                                        border: "1px solid black",
                                        height: "100%",
                                        width: "100%",
                                        objectFit: "cover",
                                        borderRadius: "3px",
                                    }}
                                    className="hover-img"
                                    onMouseOver={(e) => {
                                        e.target.style.cursor = "pointer";
                                        e.target.style.opacity = "0.8";
                                        e.target.style.boxShadow = "0px 0px 2px 0 rgba(0,0,0,1)";
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.boxShadow = "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                    }}
                                    onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                />
                            </a>
                            <p style={{textAlign: "center"}}>Container Number</p>
                        </div>
                    )}
                </div>
            )}
            {claimForm.transportId !== 2 &&
                claimForm.inspection.inspectionReport.inspectionContainerDetails
                    .comment && (
                    <p>
                        We observed that:{" "}
                        {
                            claimForm.inspection.inspectionReport.inspectionContainerDetails
                                .comment
                        }
                    </p>
                )}

            <b style={{paddingTop: "2.6rem", display: "block"}}>NARRATIVE</b>
            <div style={{height: "20px"}}></div>
            <p>
                The subject{" "}
                <span>
          {claimForm.transportId === 1
              ? "container"
              : claimForm.transportId === 2
                  ? "air shippment"
                  : "truck"}
        </span>{" "}
                was shipped under a
                <span>
          {claimForm.transportId === 1
              ? " BL "
              : claimForm.transportId === 2
                  ? " AWB "
                  : " TCR "}
                    Nro:{claimForm.blAwb.replace("|||", "-")}, dated the{" "}
                    {claimForm.blAwbDate}
        </span>
                , which was loaded
                {claimForm.transportId === 1 &&
                    ` on board the vessel ${claimForm.vessel} `}{" "}
                on {claimForm.blAwbDate}, at{" "}
                {claimForm.transportId === 1 && "the port of"} {claimForm.pol} for
                transportation to {claimForm.transportId === 1 && "the port of"}{" "}
                {claimForm.pod}
            </p>
            {claimForm.inspection.inspectionReport.inspectionFruit.length > 0 && (
                <b style={{paddingTop: "2.6rem", display: "block"}}>
                    PACKING AND STORAGE
                </b>
            )}
            <div style={{height: "20px"}}></div>
            {claimForm.inspection.inspectionReport.inspectionContainerDetails
                    .isContainerAvailable &&
                !claimForm.inspection.inspectionReport.isCargoAvailable &&
                claimForm.inspection.inspectionReport.isFruitInsideOfContainer &&
                "Upon our arrival, we found that the consignment was still located inside the subject container, and we therefore proceeded with an inspection on the reefer unit itself."}
            {!claimForm.inspection.inspectionReport.isCargoAvailable &&
            claimForm.inspection.inspectionReport.isCargoOutOfStorageArea ? (
                <p style={{paddingBottom: "30px"}}>
                    Cargo was not available for our inspection, having already been
                    disposed of or already sold and distributed from the cold storage.
                </p>
            ) : (
                <>
                    {claimForm.inspection.inspectionReport.inspectionFruit.length > 0 && (
                        <p>
                            Cargo was found mostly as{" "}
                            {claimForm.inspection.inspectionReport.inspectionFruit.length >
                                0 &&
                                claimForm.inspection.inspectionReport.inspectionFruit.map(
                                    (item, index) => {
                                        let modalityName = "";
                                        switch (item.modalityId) {
                                            case 0:
                                                modalityName = "Pallet";
                                                break;
                                            case 1:
                                                modalityName = "Box";
                                                break;
                                            case 2:
                                                modalityName = "Bin";
                                                break;
                                            case 3:
                                                modalityName = "Other";
                                                break;
                                            default:
                                                break;
                                        }
                                        return (
                                            <span key={index}>
                        {modalityName}
                                                {index !==
                                                    claimForm.inspection.inspectionReport.inspectionFruit
                                                        .length -
                                                    1 && ", "}
                      </span>
                                        );
                                    }
                                )}
                            , stored in a{" "}
                            {claimForm.inspection.inspectionReport.inspectionFruit.length >
                                0 &&
                                claimForm.inspection.inspectionReport.inspectionFruit.map(
                                    (item, index) => {
                                        let location = "";
                                        switch (item.locationId) {
                                            case 0:
                                                location = "Refrigerated cold storage";
                                                break;
                                            case 1:
                                                location = "Non refrigerated cold storage";
                                                break;
                                            case 2:
                                                location = "Other";
                                                break;
                                            default:
                                                location = item.location; // Valor por defecto si no coincide con ningún caso
                                        }
                                        return (
                                            <span key={index}>
                        {` ${location}`}
                                                {index !==
                                                    claimForm.inspection.inspectionReport.inspectionFruit
                                                        .length -
                                                    1 && ", "}
                      </span>
                                        );
                                    }
                                )}
                            {` in `}{" "}
                            {claimForm.inspection.inspectionReport.inspectionFruit.length >
                                0 &&
                                claimForm.inspection.inspectionReport.inspectionFruit.map(
                                    (item, index) => {
                                        let cargoStorage = "";
                                        switch (item.cargoStorageId) {
                                            case 0:
                                                cargoStorage = "Metal racks";
                                                break;
                                            case 1:
                                                cargoStorage = "Rows on floor";
                                                break;
                                            case 2:
                                                cargoStorage = "Double stacked";
                                                break;
                                            default:
                                                cargoStorage = item.cargoStorage; // Valor por defecto si no coincide con ningún caso
                                        }
                                        return (
                                            <span key={index}>
                        {cargoStorage}
                                                {index !==
                                                    claimForm.inspection.inspectionReport.inspectionFruit
                                                        .length -
                                                    1 && ", "}
                      </span>
                                        );
                                    }
                                )}
                            .
                        </p>
                    )}

                    {
                        /*claimForm.inspection.inspectionReport.inspectionContainerDetails.isContainerAvailable &&*/
                        <div
                            style={{
                                height: "100%",
                                display: "flex",
                                justifyContent: "space-around",
                                margin: "2rem 0",
                                gap: "25px",
                            }}
                        >
                            <div style={{height: "500px", width: "33%"}}>
                                {claimForm.inspection.inspectionReport.inspectionFruit.length >
                                    0 && (
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport.inspectionFruit[0]
                                                    .cargoAirTemperatureUrl
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport.inspectionFruit[0]
                                                        .cargoAirTemperatureUrl !== ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionFruit[0].cargoAirTemperatureUrl
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="Cargo Air Temperature"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                            />
                                        </a>
                                    )}
                                <p style={{textAlign: "center"}}>Temperature of the room</p>
                            </div>
                            <div style={{height: "500px", width: "33%"}}>
                                {claimForm.inspection.inspectionReport.inspectionFruit.length >
                                    0 && (
                                        <a
                                            href={
                                                claimForm.inspection.inspectionReport.inspectionFruit[0]
                                                    .cargoStoredUrl
                                            }
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <img
                                                src={
                                                    claimForm.inspection.inspectionReport.inspectionFruit[0]
                                                        .cargoStoredUrl !== ""
                                                        ? claimForm.inspection.inspectionReport
                                                            .inspectionFruit[0].cargoStoredUrl
                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                }
                                                alt="Cargo Storage"
                                                style={{
                                                    border: "1px solid black",
                                                    height: "100%",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "3px",
                                                }}
                                                className="hover-img"
                                                onMouseOver={(e) => {
                                                    e.target.style.cursor = "pointer";
                                                    e.target.style.opacity = "0.8";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                }}
                                                onMouseOut={(e) => {
                                                    e.target.style.opacity = "1";
                                                    e.target.style.boxShadow =
                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                }}
                                                onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                            />
                                        </a>
                                    )}
                                <p style={{textAlign: "center"}}>Storage condition</p>
                            </div>
                        </div>
                    }
                    {/*<div style={{height:'15px'}}> </div>*/}
                    {claimForm.inspection.inspectionReport.inspectionFruit.length > 0 && (
                        <p style={{fontSize: "1.1rem"}}>
                            {
                                claimForm.inspection.inspectionReport.inspectionFruit[0]
                                    .totalPackageAvailable
                            }{" "}
                            {claimForm.inspection.inspectionReport.inspectionFruit[0]
                                .modalityId === 0
                                ? "Pallets"
                                : claimForm.inspection.inspectionReport.inspectionFruit[0]
                                    .modalityId === 1
                                    ? "Boxes"
                                    : claimForm.inspection.inspectionReport.inspectionFruit[0]
                                        .modalityId === 2
                                        ? "Bines"
                                        : claimForm.inspection.inspectionReport.inspectionFruit[0]
                                            .modalityId === 3
                                            ? "Other"
                                            : claimForm.inspection.inspectionReport.inspectionFruit[0]
                                                .modality}{" "}
                            were available for inspection.
                        </p>
                    )}
                    <p style={{fontSize: "1.1rem"}}>
                        The cargo was shipped:
                        <ul>
                            {claimForm.inspection.inspectionReport.inspectionGeneral
                                .coldTreatment && (
                                <li>
                                    <b>' under Cold Treatment'</b>
                                </li>
                            )}
                            {claimForm.inspection.inspectionReport.inspectionGeneral
                                .fumigated && (
                                <li>
                                    <b>' fumigated'</b>
                                </li>
                            )}
                            {claimForm.inspection.inspectionReport.inspectionGeneral
                                .nonFumigated && (
                                <li>
                                    <b>' non fumigated'</b>
                                </li>
                            )}
                            {claimForm.inspection.inspectionReport.inspectionGeneral
                                .preInspected && (
                                <li>
                                    <b>' pre-inspected'</b>
                                </li>
                            )}
                            {claimForm.inspection.inspectionReport.inspectionGeneral.none && (
                                <li>
                                    <b>' without any special treatment' </b>
                                </li>
                            )}
                        </ul>
                    </p>
                    {claimForm.inspection.inspectionReport.inspectionFruit.length !==
                        0 && (
                            <>
                                <b style={{paddingTop: "2.6rem", display: "block"}}>
                                    PULP TEMPERATURE
                                </b>
                                <div style={{height: "20px"}}></div>
                                {claimForm.inspection.inspectionReport.inspectionFruit.length >
                                    0 && (
                                        <p>
                                            The pulp temperature of the fruit was checked by means of a
                                            digital probe thermometer and this in the center of the fruit,
                                            whereby the following values were recorded in{" "}
                                            {
                                                claimForm.inspection.inspectionReport.inspectionFruit[0]
                                                    .scaleTemperature
                                            }{" "}
                                            :
                                        </p>
                                    )}

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                        padding: "2rem",
                                    }}
                                >
                                    <table style={{border: "3px solid #e1e1e1"}}>
                                        <tr style={{backgroundColor: "#1c36af", color: "white"}}>
                                            <th
                                                style={{
                                                    backgroundColor: "#1c36af",
                                                    color: "white",
                                                    padding: ".4rem 1rem",
                                                    border: "3px solid #e1e1e1",
                                                    textAlign: "center",
                                                }}
                                            >
                                                PALLET NUMBER
                                            </th>
                                            <th
                                                style={{
                                                    backgroundColor: "#1c36af",
                                                    color: "white",
                                                    padding: ".4rem 1rem",
                                                    border: "3px solid #e1e1e1",
                                                    textAlign: "center",
                                                }}
                                            >
                                                TOP
                                            </th>
                                            <th
                                                style={{
                                                    backgroundColor: "#1c36af",
                                                    color: "white",
                                                    padding: ".4rem 1rem",
                                                    border: "3px solid #e1e1e1",
                                                    textAlign: "center",
                                                }}
                                            >
                                                MIDDLE
                                            </th>
                                            <th
                                                style={{
                                                    backgroundColor: "#1c36af",
                                                    color: "white",
                                                    padding: ".4rem 1rem",
                                                    border: "3px solid #e1e1e1",
                                                    textAlign: "center",
                                                }}
                                            >
                                                BOTTOM
                                            </th>
                                        </tr>
                                        {palletsSurvey !== undefined &&
                                            palletsSurvey.map((pallet, index) => {
                                                //console.log(palletsSurvey[0])
                                                return (
                                                    <tr key={index} style={{border: "3px solid #e1e1e1"}}>
                                                        <td
                                                            style={{
                                                                border: "3px solid #e1e1e1",
                                                                padding: ".4rem 1rem",
                                                                textAlign: "center",
                                                                minWidth: "13ch",
                                                            }}
                                                        >
                                                            {pallet.palletNumber}
                                                        </td>
                                                        <td
                                                            style={{
                                                                border: "3px solid #e1e1e1",
                                                                padding: ".4rem 1rem",
                                                                textAlign: "center",
                                                                minWidth: "13ch",
                                                            }}
                                                        >
                                                            {pallet.top}
                                                        </td>
                                                        <td
                                                            style={{
                                                                border: "3px solid #e1e1e1",
                                                                padding: ".4rem 1rem",
                                                                textAlign: "center",
                                                                minWidth: "13ch",
                                                            }}
                                                        >
                                                            {pallet.middle}
                                                        </td>
                                                        <td
                                                            style={{
                                                                border: "3px solid #e1e1e1",
                                                                padding: ".4rem 1rem",
                                                                textAlign: "center",
                                                                minWidth: "13ch",
                                                            }}
                                                        >
                                                            {pallet.bottom}
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        <tr>
                                            <td
                                                style={{
                                                    border: "3px solid #e1e1e1",
                                                    backgroundColor: "#e1e1e1",
                                                    fontWeight: "bolder",
                                                    padding: ".4rem 1rem",
                                                    textAlign: "center",
                                                    minWidth: "13ch",
                                                }}
                                            >
                                                AVERAGE RANGE (
                                                {claimForm.inspection.inspectionReport.inspectionFruit
                                                        .length > 0 &&
                                                    claimForm.inspection.inspectionReport.inspectionFruit[0]
                                                        .scaleTemperature}
                                                )
                                            </td>
                                            <td
                                                style={{
                                                    border: "3px solid #e1e1e1",
                                                    backgroundColor: "#e1e1e1",
                                                    fontWeight: "bolder",
                                                    padding: ".4rem 1rem",
                                                    textAlign: "center",
                                                    minWidth: "13ch",
                                                }}
                                            >
                                                {averageSurvey !== undefined && averageSurvey.top}
                                            </td>
                                            <td
                                                style={{
                                                    border: "3px solid #e1e1e1",
                                                    backgroundColor: "#e1e1e1",
                                                    fontWeight: "bolder",
                                                    padding: ".4rem 1rem",
                                                    textAlign: "center",
                                                    minWidth: "13ch",
                                                }}
                                            >
                                                {averageSurvey !== undefined && averageSurvey.middle}
                                            </td>
                                            <td
                                                style={{
                                                    border: "3px solid #e1e1e1",
                                                    backgroundColor: "#e1e1e1",
                                                    fontWeight: "bolder",
                                                    padding: ".4rem 1rem",
                                                    textAlign: "center",
                                                    minWidth: "13ch",
                                                }}
                                            >
                                                {averageSurvey !== undefined && averageSurvey.bottom}
                                            </td>
                                        </tr>
                                    </table>
                                </div>

                                <div
                                    style={{
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "space-around",
                                        margin: "2rem 0 6rem 0",
                                        gap: "25px",
                                    }}
                                >
                                    {allPalletsTemp.length > 0 &&
                                        allPalletsTemp.map((content, idx) => {
                                            if (idx >= 3) {
                                                return null;
                                            } else {
                                                return (
                                                    <div
                                                        key={idx}
                                                        style={{height: "500px", width: "33%"}}
                                                    >
                                                        <a
                                                            href={content.photo}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <img
                                                                src={content.photo}
                                                                alt="Temperatura de pulpa pallet"
                                                                style={{
                                                                    border: "1px solid black",
                                                                    height: "100%",
                                                                    width: "100%",
                                                                    objectFit: "cover",
                                                                    borderRadius: "3px",
                                                                }}
                                                                className="hover-img"
                                                                onMouseOver={(e) => {
                                                                    e.target.style.cursor = "pointer";
                                                                    e.target.style.opacity = "0.8";
                                                                    e.target.style.boxShadow =
                                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                                }}
                                                                onMouseOut={(e) => {
                                                                    e.target.style.opacity = "1";
                                                                    e.target.style.boxShadow =
                                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                                }}
                                                                // onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                                            />
                                                        </a>
                                                        <p style={{textAlign: "center"}}>
                                                            Temperature -{" "}
                                                            {content.position.charAt(0).toUpperCase() +
                                                                content.position.slice(1)}{" "}
                                                            {content.numberPallet &&
                                                                `- ${content.numberPallet}`}
                                                        </p>
                                                    </div>
                                                );
                                            }
                                        })}
                                </div>

                                <b style={{color: "#4371d6"}}>FRUIT INSPECTION</b>
                                <div style={{height: "20px"}}></div>

                                <p>
                                    To have a general impression of the quality of the consignment,
                                    we inspected several cases which were chosen at random.
                                </p>
                                <p>
                                    The cargo consisted
                                    {claimForm.cargo.fruits.map((fruit, index) => {
                                        return (
                                            <span key={index}>
                      {index === 0 && " in "}
                                                {fruit.boxes} boxes of {fruit.name}
                                                {index !==
                                                    claimForm.inspection.inspectionReport.inspectionFruit
                                                        .length -
                                                    1 && ", "}
                                                {index ===
                                                    claimForm.inspection.inspectionReport.inspectionFruit
                                                        .length -
                                                    1 && ". "}
                    </span>
                                        );
                                    })}
                                </p>
                                <p>
                                    {claimForm.inspection.inspectionReport.inspectionFruit.map(
                                        (fruit, index) => {
                                            return (
                                                <span key={index}>
                        The cargo were packed
                                                    {index ===
                                                        claimForm.inspection.inspectionReport.inspectionFruit
                                                            .length -
                                                        1 && " in "}
                                                    {fruit.inspectionPacket.map((material, index) => {
                                                        if (material.packetMaterial !== "") {
                                                            material.packetMaterial.split(",").map((m, i) => {
                                                                let packetMaterial = "";
                                                                switch (m.trim()) {
                                                                    case "Cartón":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("Cartons");
                                                                        break;
                                                                    case "Madera":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("Woods");
                                                                        break;
                                                                    case "Cartón plástico":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Cardboard plastic"
                                                                            );
                                                                        break;
                                                                    case "Panel de fibra de doble pared":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Double wall fiberboard"
                                                                            );
                                                                        break;
                                                                    case "Map":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("Map");
                                                                        break;
                                                                    case "Bolsa perforada":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Perforated Bag"
                                                                            );
                                                                        break;
                                                                    case "Revestimientos":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("Liners");
                                                                        break;
                                                                    case "Plastic":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("Plastic");
                                                                        break;
                                                                    case "Single wall fiberboard":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Single wall fiberboard"
                                                                            );
                                                                        break;
                                                                    case "Wood":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("Wood");
                                                                        break;
                                                                    case "Open top":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("Open top");
                                                                        break;
                                                                    case "Telescoping lid":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Telescoping lid"
                                                                            );
                                                                        break;
                                                                    case "Removable top lid":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Removable top lid"
                                                                            );
                                                                        break;
                                                                    case "Folding lids":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Folding lids"
                                                                            );
                                                                        break;
                                                                    case "Column stacked":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Column stacked"
                                                                            );
                                                                        break;
                                                                    case "Cross stacked":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Cross stacked"
                                                                            );
                                                                        break;
                                                                    case "Volume filled":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Volume filled"
                                                                            );
                                                                        break;
                                                                    case "Tray packed":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Tray packed"
                                                                            );
                                                                        break;
                                                                    case "Layer packed":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Layer packed"
                                                                            );
                                                                        break;
                                                                    case "Polyethene liner":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Polyethene liner"
                                                                            );
                                                                        break;
                                                                    case "So2 pad":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push("So2 pad");
                                                                        break;
                                                                    case "Slider bags":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Slider bags"
                                                                            );
                                                                        break;
                                                                    case "Clamshells":
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                "Clamshells"
                                                                            );
                                                                        break;
                                                                    default:
                                                                        packetMaterial =
                                                                            inspectionFruitPacketList.push(
                                                                                material.packetMaterial
                                                                            ); // Valor por defecto si no coincide con ningún caso
                                                                }
                                                            });
                                                        }
                                                    })}
                                                    <span>
                          {inspectionFruitPacketList.toString().concat(". ")}
                        </span>
                        Per each box were measured {fruit.totalSpeciesToInspect}{" "}
                                                    pieces
                                                    {index !==
                                                        claimForm.inspection.inspectionReport.inspectionFruit
                                                            .length -
                                                        1 && ", "}
                      </span>
                                            );
                                        }
                                    )}
                                    {additionalDescription.length > 0 && (
                                        <div style={{display: "block", margin: "1.7rem 0 .5rem 0"}}>
                                            <b>Additional Descriptions:</b>
                                            {additionalDescription.map((description, index) => {
                                                return (
                                                    <span key={index}>
                          {index === additionalDescription.length - 1 && " "}
                                                        {description}
                                                        {index !== additionalDescription.length - 1 && ", "}
                        </span>
                                                );
                                            })}
                                        </div>
                                    )}

                                    {/*Per each box were measured {claimForm.inspection.inspectionReport.inspectionFruit[0].totalSpeciesToInspect} pieces*/}
                                </p>
                                <div style={{height: "25px"}}></div>
                                <b>QUALITY AND CONDITION PROBLEMS</b>
                                <div style={{height: "20px"}}></div>

                                <p>The following quality and condition problems were found:</p>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                        paddingTop: "1rem",
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            padding: "1rem",
                                            flexDirection: "column",
                                        }}
                                    >
                                        {allPalletsGraphic()}
                                    </div>
                                </div>

                                <div
                                    style={{
                                        height: "100%",
                                        display: "flex",
                                        justifyContent: "space-around",
                                        margin: "2rem 0 5rem 0",
                                        gap: "25px",
                                    }}
                                >
                                    {allPalletsDamage.boxes.flatMap((box, boxIndex) => {
                                        return box.problemInspection.map((problem, problemIndex) => {
                                            if (countPhotoDamage >= 3) return null;

                                            // if(typeof problem.photo === 'string'){
                                            //     countPhotoDamage++;
                                            // }

                                            // if(problem.severity !== "High"){
                                            //     if(boxIndex === allPalletsDamage.boxes.length - 1 && problemIndex === box.problemInspection.length - 1){
                                            //         return (
                                            //             <div>No high severity in Pallets</div>
                                            //         )
                                            //     }
                                            //     return null;
                                            // }else{
                                            //     countPhotoDamage++;
                                            // }
                                            if (/rsk/.test(problem.photo)) {
                                                countPhotoDamage++;

                                                return (
                                                    <div
                                                        key={`${boxIndex}-${problemIndex}`}
                                                        style={{height: "500px", width: "33%"}}
                                                    >
                                                        <a
                                                            href={problem.photo}
                                                            target="_blank"
                                                            rel="noreferrer"
                                                        >
                                                            <img
                                                                src={
                                                                    problem.photo !== ""
                                                                        ? problem.photo
                                                                        : "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png"
                                                                }
                                                                alt="problem"
                                                                className="hover-img"
                                                                style={{
                                                                    border: "1px solid black",
                                                                    height: "100%",
                                                                    width: "100%",
                                                                    objectFit: "cover",
                                                                    borderRadius: "3px",
                                                                }}
                                                                onMouseOver={(e) => {
                                                                    e.target.style.cursor = "pointer";
                                                                    e.target.style.opacity = "0.8";
                                                                    e.target.style.boxShadow =
                                                                        "0px 0px 2px 0 rgba(0,0,0,1)";
                                                                }}
                                                                onMouseOut={(e) => {
                                                                    e.target.style.opacity = "1";
                                                                    e.target.style.boxShadow =
                                                                        "0px 0px 10px 0 rgba(0,0,0,0.8)";
                                                                }}
                                                                // onError="this.onerror = null; this.src='https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1665px-No-Image-Placeholder.svg.png'"
                                                            />
                                                        </a>
                                                        <p style={{textAlign: "center"}}>
                                                            {problem.problem}{" "}
                                                            {box.palletNumber && `- ${box.palletNumber}`}{" "}
                                                        </p>
                                                    </div>
                                                );
                                            } else {
                                                return null;
                                            }
                                        });
                                    })}
                                </div>
                            </>
                        )}
                </>
            )}

            {claimForm.inspection.inspectionReport.inspectionFruit.length === 0 && (
                <div style={{height: "55px"}}></div>
            )}
            <b>TRANSIT INFORMATION</b>
            <div
                style={{display: "flex", justifyContent: "center", marginTop: "1rem"}}
            >
                <div style={{display: "flex"}}>
                    <div
                        style={{display: "flex", flexDirection: "column", width: "50%"}}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                justifyContent: "start",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "400px",
                                    height: "70px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70px",
                                        height: "70px",
                                        border: "2px solid #68dbc9",
                                        borderRadius: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            id="_x32_"
                                            width="40px"
                                            height="40px"
                                            viewBox="0 0 512 512"
                                        >
                                            <g>
                                                <path
                                                    className="st0"
                                                    d="M422.969,193.281c2.313-7.922,3.594-16.313,3.594-24.969c0-42.469-29.375-78.063-68.875-87.844   C346.813,34.406,305.438,0,256,0s-90.813,34.406-101.75,80.469c-39.438,9.781-68.813,45.375-68.813,87.844   c0,8.656,1.281,17.047,3.594,24.969C64.313,212.469,48.406,242.313,48.406,276c0,57.75,46.781,104.563,104.563,104.563   c14.625,0,28.563-2.969,41.188-8.406c1.922,1.594,3.844,3.125,5.844,4.563V512h112V376.641c2-1.438,3.922-2.891,5.75-4.484   c12.719,5.438,26.656,8.406,41.281,8.406c57.781,0,104.563-46.813,104.563-104.563   C463.594,242.313,447.688,212.469,422.969,193.281z M280,480h-48v-88.156c7.688,2,15.688,3.031,24,3.031s16.313-1.031,24-3.031V480   z M359.031,348.563c-9.906,0-19.5-1.922-28.625-5.844l-18.156-7.844l-0.25,0.25l-14.875,12.625   c-5.203,4.328-10.969,7.844-17.125,10.328c-7.594,3.125-15.688,4.797-24,4.797s-16.406-1.672-24-4.797   c-6.156-2.484-11.922-6-17.125-10.328L200,335.125l-0.25-0.25l-18.156,7.844c-9.125,3.922-18.719,5.844-28.625,5.844   c-40,0-72.563-32.563-72.563-72.563c0-22.563,10.234-43.438,28.234-57.359l17.109-13.281l-6-20.891   c-1.5-5.438-2.313-10.875-2.313-16.156c0-26.953,18.313-50.313,44.484-56.719l18.953-4.719l4.563-19.031   C193.188,54.969,222.25,32,256,32s62.813,22.969,70.563,55.844l4.469,19.031l19.047,4.719   c26.172,6.406,44.484,29.766,44.484,56.719c0,5.281-0.813,10.719-2.313,16.156l-6,20.891l17.109,13.281   c18,13.922,28.234,34.797,28.234,57.359C431.594,316,399.031,348.563,359.031,348.563z"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                                {/*aca va el icono del HARVEST DATE*/}
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{padding: ".3rem 1rem 0 1rem", fontWeight: "600"}}
                                    >
                                        Harvest date
                                        <span
                                            style={{
                                                paddingLeft: ".5rem",
                                                fontWeight: "400",
                                                color: "#a1a1a1",
                                            }}
                                        >
                      | {fechaHar}
                    </span>
                                    </div>
                                    <div
                                        style={{
                                            padding: "0 1rem 0 1rem",
                                            fontWeight: "400",
                                            color: "#a1a1a1",
                                        }}
                                    >
                                        {/*Linares - Chile*/}
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "70px",
                                    height: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "3px",
                                        height: "10px",
                                        border: "2px solid #68dbc9",
                                        marginLeft: "35px",
                                        backgroundColor: "#68dbc9",
                                    }}
                                ></div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "400px",
                                    height: "70px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70px",
                                        height: "70px",
                                        border: "2px solid #68dbc9",
                                        borderRadius: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.1"
                                            id="_x32_"
                                            width="40px"
                                            height="40px"
                                            viewBox="0 0 512 512"
                                        >
                                            <g>
                                                <g>
                                                    <g>
                                                        <path
                                                            d="M503.979,219.714h-9.362V82.81h5.323c4.431,0,8.021-3.591,8.021-8.021V37.731c0-4.431-3.59-8.021-8.021-8.021H117.701     c-4.431,0-8.021,3.59-8.021,8.021v37.058c0,4.43,3.59,8.021,8.021,8.021h5.325v136.904H8.021c-4.431,0-8.021,3.59-8.021,8.021     v48.082c0,4.431,3.59,8.021,8.021,8.021h9.294v190.43c0,4.431,3.59,8.021,8.021,8.021h461.328c4.431,0,8.021-3.59,8.021-8.021     v-190.43h9.293c4.431,0,8.021-3.59,8.021-8.021v-48.082C512,223.304,508.41,219.714,503.979,219.714z M351.616,45.751h140.302     v21.016H351.616V45.751z M351.616,82.81h126.958v136.904H351.616V82.81z M125.723,45.751h209.852v21.016H125.723V45.751z      M226.348,199.902v-0.001c4.431,0,8.021-3.59,8.021-8.021v-40.618c0-4.431-3.59-8.021-8.021-8.021h-87.279V82.81h196.506v136.904     H139.068v-19.812H226.348z M139.068,183.858v-24.576h79.258v24.576H139.068z M33.358,466.247v-30.481H148.99     c4.431,0,8.021-3.59,8.021-8.021v-52.703c0-4.431-3.59-8.021-8.021-8.021H33.358v-83.182h259.741v182.408H33.358z      M33.358,419.724v-36.66h107.612v36.66H33.358z M293.1,267.796H16.042v-32.04H293.1V267.796z M478.643,466.247H309.142V283.839     h169.501V466.247z M495.958,267.796H309.142v-32.04h186.815V267.796z"/>
                                                        <path
                                                            d="M376.32,342.013h59.629c12.238,0,22.195-9.958,22.195-22.196s-9.957-22.195-22.195-22.195H376.32     c-12.238,0-22.196,9.957-22.196,22.195S364.082,342.013,376.32,342.013z M376.32,313.664h59.629c3.392,0,6.153,2.76,6.153,6.153     c0,3.393-2.76,6.154-6.153,6.154H376.32c-3.393,0-6.154-2.76-6.154-6.154C370.167,316.424,372.927,313.664,376.32,313.664z"/>
                                                        <path
                                                            d="M447.509,89.753h-45.956c-10.447,0-18.946,8.498-18.946,18.945c0,10.448,8.499,18.947,18.946,18.947h45.956     c10.447,0,18.946-8.499,18.946-18.947C466.456,98.251,457.955,89.753,447.509,89.753z M447.509,111.603h-45.956     c-1.601,0-2.904-1.304-2.904-2.905c0-1.6,1.303-2.903,2.904-2.903h45.956c1.601,0,2.904,1.303,2.904,2.903     C450.413,110.299,449.11,111.603,447.509,111.603z"/>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                </div>

                                {/*aca va el icono del PACKING DATE*/}
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{padding: ".3rem 1rem 0 1rem", fontWeight: "600"}}
                                    >
                                        Packing date
                                        <span
                                            style={{
                                                paddingLeft: ".5rem",
                                                fontWeight: "400",
                                                color: "#a1a1a1",
                                            }}
                                        >
                      | {fechaPack}
                    </span>
                                    </div>
                                    <div
                                        style={{
                                            padding: "0 1rem 0 1rem",
                                            fontWeight: "400",
                                            color: "#a1a1a1",
                                        }}
                                    >
                                        {/*Linares - Chile*/}
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "70px",
                                    height: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "3px",
                                        height: "10px",
                                        border: "2px solid #68dbc9",
                                        marginLeft: "35px",
                                        backgroundColor: "#68dbc9",
                                    }}
                                ></div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "400px",
                                    height: "70px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70px",
                                        height: "70px",
                                        border: "2px solid #68dbc9",
                                        borderRadius: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.0"
                                            width="256.000000pt"
                                            height="256.000000pt"
                                            viewBox="-25 -20 306.000000 306.000000"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <g
                                                transform="translate(0.000000,256.000000) scale(0.100000,-0.100000)"
                                                fill="#000000"
                                                stroke="none"
                                            >
                                                <path
                                                    d="M474 2171 c-215 -124 -399 -233 -409 -241 -17 -14 -18 -42 -12 -479 4 -367 8 -466 19 -477 21 -21 1341 -787 1363 -791 12 -2 62 21 122 56 56 34 104 61 107 61 3 0 55 -29 116 -65 61 -36 120 -65 131 -65 18 0 19 8 19 143 l0 142 151 88 151 87 124 -72 c86 -49 128 -68 135 -61 7 7 13 137 16 350 l6 340 -126 73 -127 73 0 126 0 126 -436 259 c-393 233 -437 257 -451 243 -8 -8 -13 -19 -9 -25 3 -5 182 -112 398 -237 216 -126 399 -234 406 -240 10 -9 -67 -57 -350 -220 -200 -115 -370 -209 -378 -209 -22 0 -1301 745 -1298 755 2 5 167 103 368 218 l365 210 65 -36 c36 -19 84 -46 106 -59 39 -23 43 -23 58 -9 9 9 14 20 11 25 -7 12 -229 140 -241 139 -5 0 -185 -103 -400 -228z m290 -691 l645 -375 1 -428 0 -429 -42 25 c-153 88 -1100 639 -1175 683 l-93 55 0 425 c0 246 4 424 9 422 5 -1 299 -172 655 -378z m1446 -30 l0 -81 -44 26 -44 26 -148 -87 c-82 -47 -215 -124 -296 -171 l-148 -85 0 -347 0 -346 46 -26 46 -26 -71 -41 -71 -41 0 428 0 427 358 211 c196 116 360 212 365 212 4 1 7 -35 7 -79z m-120 -407 l0 -298 -75 -42 c-41 -24 -77 -43 -79 -43 -3 0 -7 46 -8 102 l-3 103 -162 95 c-90 52 -163 97 -163 100 0 6 471 278 483 279 4 1 7 -133 7 -296z m220 211 l150 -86 0 -299 c0 -164 -3 -299 -6 -299 -3 0 -72 39 -154 88 l-150 87 0 298 c0 163 2 297 5 297 3 0 73 -39 155 -86z m-577 -333 l147 -83 0 -300 0 -299 -62 35 c-35 20 -105 60 -155 89 l-93 52 0 298 c0 164 4 297 8 295 5 -1 74 -41 155 -87z m431 -246 c11 -8 18 -16 15 -18 -9 -8 -231 -137 -235 -137 -3 0 -4 17 -2 37 3 36 7 40 88 85 92 52 105 55 134 33z"/>
                                                <path
                                                    d="M196 1614 c-8 -20 -8 -468 0 -488 3 -9 14 -16 24 -16 10 0 21 7 24 16 8 20 8 468 0 488 -3 9 -14 16 -24 16 -10 0 -21 -7 -24 -16z"/>
                                                <path
                                                    d="M382 1518 c-9 -9 -12 -78 -12 -249 0 -131 3 -244 6 -253 7 -19 44 -22 45 -3 4 63 -1 499 -6 507 -8 13 -18 13 -33 -2z"/>
                                                <path
                                                    d="M555 1407 c-3 -7 -4 -123 -3 -257 l3 -245 23 -3 22 -3 0 260 c0 256 0 261 -20 261 -11 0 -23 -6 -25 -13z"/>
                                                <path
                                                    d="M737 1314 c-4 -4 -7 -119 -7 -254 0 -211 2 -249 15 -260 10 -9 19 -10 26 -3 6 6 8 108 7 264 -3 220 -5 254 -18 257 -9 1 -19 0 -23 -4z"/>
                                                <path
                                                    d="M915 1197 c-3 -7 -4 -123 -3 -257 l3 -245 23 -3 22 -3 0 260 c0 256 0 261 -20 261 -11 0 -23 -6 -25 -13z"/>
                                                <path
                                                    d="M1097 1104 c-4 -4 -7 -121 -7 -260 0 -201 3 -253 13 -257 35 -13 37 5 35 264 -3 220 -5 254 -18 257 -9 1 -19 0 -23 -4z"/>
                                                <path
                                                    d="M1275 998 c-3 -7 -4 -126 -3 -263 3 -242 4 -250 23 -250 19 0 20 7 20 260 0 240 -1 260 -18 263 -9 2 -19 -3 -22 -10z"/>
                                                <path
                                                    d="M2194 1168 c-9 -15 19 -37 110 -88 82 -45 106 -49 106 -20 0 14 -24 34 -85 70 -86 50 -118 60 -131 38z"/>
                                                <path
                                                    d="M2203 1023 c-34 -12 -9 -41 78 -91 50 -29 98 -52 105 -52 21 0 29 29 13 44 -26 24 -184 104 -196 99z"/>
                                                <path
                                                    d="M2193 854 c-8 -21 -2 -25 101 -83 68 -38 93 -48 103 -39 26 21 12 37 -78 87 -98 55 -116 60 -126 35z"/>
                                                <path
                                                    d="M1627 843 c-18 -18 1 -36 89 -87 92 -51 124 -60 124 -31 0 16 -23 34 -107 83 -70 41 -93 49 -106 35z"/>
                                                <path
                                                    d="M1623 675 c-7 -20 -9 -19 99 -80 92 -53 118 -58 118 -25 0 12 -30 35 -90 69 -95 54 -117 60 -127 36z"/>
                                                <path
                                                    d="M1624 525 c-9 -22 -1 -29 97 -84 88 -51 119 -58 119 -27 0 17 -29 39 -121 89 -73 41 -87 44 -95 22z"/>
                                                <path
                                                    d="M589 2094 c-156 -91 -288 -169 -294 -175 -6 -6 -4 -14 5 -23 24 -23 1120 -656 1136 -656 17 0 550 303 574 326 9 9 11 17 5 23 -6 6 -246 148 -535 317 -289 168 -543 317 -566 330 l-41 24 -284 -166z m813 -200 c288 -168 526 -309 531 -313 4 -4 -106 -71 -243 -149 l-251 -142 -529 308 c-291 169 -530 309 -530 312 1 5 480 287 492 289 4 1 242 -137 530 -305z"/>
                                                <path
                                                    d="M1162 2207 c-15 -18 -5 -29 54 -66 52 -32 78 -38 88 -22 11 18 -5 36 -60 69 -62 36 -67 37 -82 19z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                                {/*aca va el icono del STUFFING DATE*/}

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{padding: ".3rem 1rem 0 1rem", fontWeight: "600"}}
                                    >
                                        Stuffing date
                                        <span
                                            style={{
                                                paddingLeft: ".5rem",
                                                fontWeight: "400",
                                                color: "#a1a1a1",
                                            }}
                                        >
                      {claimForm.stuffingDate === null ||
                      claimForm.stuffingDate === ""
                          ? "Not defined"
                          : claimForm.stuffingDate}
                    </span>
                                    </div>
                                    <div
                                        style={{
                                            padding: "0 1rem 0 1rem",
                                            fontWeight: "400",
                                            color: "#a1a1a1",
                                        }}
                                    >
                                        {/*Linares - Chile*/}
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "70px",
                                    height: "10px",
                                }}
                            ></div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                width: "3px",
                                height: "10px",
                                border: "2px solid #68dbc9",
                                marginLeft: "2.2rem",
                                marginTop: "-.7rem",
                                backgroundColor: "#68dbc9",
                            }}
                        ></div>
                        {/*aca va el icono del LANDING PORT */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "start",
                                width: "400px",
                                height: "70px",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    width: "70px",
                                    height: "70px",
                                    border: "2px solid #68dbc9",
                                    borderRadius: "100%",
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    {claimForm.transportId === 3 ? (
                                        <TbTruckDelivery
                                            style={{
                                                width: "3rem",
                                                height: "3rem",
                                                margin: "1rem",
                                                stroke: "#000000",
                                                strokeWidth: 2,
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                            }}
                                        />
                                    ) : claimForm.transportId === 2 ? (
                                        <TbPlaneDeparture
                                            style={{
                                                width: "2.5rem",
                                                height: "2.5rem",
                                                margin: "1rem",
                                                stroke: "#000000",
                                                strokeWidth: 2,
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                            }}
                                        />
                                    ) : claimForm.transportId === 1 ? (
                                        <RiShipFill
                                            style={{
                                                width: "2.5rem",
                                                height: "2.5rem",
                                                margin: "1rem",
                                                stroke: "#000000",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                            }}
                                        />
                                    ) : null}
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    width: "400px",
                                }}
                            >
                                <div
                                    style={{padding: ".3rem 1rem 0 1rem", fontWeight: "600"}}
                                >
                                    {claimForm.transportId == 1
                                        ? "Loading port"
                                        : "Loading place"}
                                    <span
                                        style={{
                                            paddingLeft: "1rem",
                                            fontWeight: "400",
                                            color: "#a1a1a1",
                                        }}
                                    >
                    | {claimForm.blAwbDate}
                  </span>
                                </div>
                                <div
                                    style={{
                                        padding: "0 1rem 0 1rem",
                                        fontWeight: "400",
                                        color: "#a1a1a1",
                                    }}
                                >
                                    {claimForm.pol}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*aca este todo el codigo de la segunda columna*/}
                    <div
                        style={{display: "flex", flexDirection: "column", width: "50%"}}
                    >
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                justifyContent: "start",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "400px",
                                    height: "70px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70px",
                                        height: "70px",
                                        border: "2px solid #68dbc9",
                                        borderRadius: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        {claimForm.transportId === 3 ? (
                                            <TbTruckDelivery
                                                style={{
                                                    width: "3rem",
                                                    height: "3rem",
                                                    margin: "1rem",
                                                    stroke: "#000000",
                                                    strokeWidth: 2,
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                }}
                                            />
                                        ) : claimForm.transportId === 2 ? (
                                            <TbPlaneArrival
                                                style={{
                                                    width: "2.5rem",
                                                    height: "2.5rem",
                                                    margin: "1rem",
                                                    stroke: "#000000",
                                                    strokeWidth: 2,
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                }}
                                            />
                                        ) : claimForm.transportId === 1 ? (
                                            <RiShipFill
                                                style={{
                                                    width: "2.5rem",
                                                    height: "2.5rem",
                                                    margin: "1rem",
                                                    stroke: "#000000",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                }}
                                            />
                                        ) : null}
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{padding: ".3rem 1rem 0 1rem", fontWeight: "600"}}
                                    >
                                        {claimForm.transportId == 1
                                            ? "Discharge port"
                                            : "Discharge place"}
                                        <span
                                            style={{
                                                paddingLeft: ".5rem",
                                                fontWeight: "400",
                                                color: "#a1a1a1",
                                            }}
                                        >
                      | {claimForm.ata || "No discharge date"}
                    </span>
                                    </div>
                                    <div
                                        style={{
                                            padding: "0 1rem 0 1rem",
                                            fontWeight: "400",
                                            color: "#a1a1a1",
                                        }}
                                    >
                                        {claimForm.pod}
                                    </div>
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "70px",
                                    height: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "3px",
                                        height: "10px",
                                        border: "2px solid #68dbc9",
                                        marginLeft: "35px",
                                        backgroundColor: "#68dbc9",
                                    }}
                                ></div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "400px",
                                    height: "70px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70px",
                                        height: "70px",
                                        border: "2px solid #68dbc9",
                                        borderRadius: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            fill="#000000"
                                            width="40px"
                                            height="40px"
                                            viewBox="0 0 50 50"
                                        >
                                            <path
                                                d="M48.406,21.063h-0.031l-4.125-5.5v-0.031L44.219,15.5C43.297,14.387,41.914,13,40,13h-8c-0.355,0-0.684,0.074-1,0.188c-0.727,0.375-2.004,1.245-2,2.719V25v0.95V27h-2V16c0-0.552-0.448-1-1-1h-4V4c0-0.552-0.448-1-1-1H9C8.448,3,8,3.448,8,4v11H4c-0.552,0-1,0.448-1,1v11H1c-0.552,0-1,0.448-1,1v6c0,2.206,1.794,4,4,4h4.09c0.478,2.833,2.942,5,5.91,5s5.431-2.167,5.91-5h13.184c0.477,2.836,2.941,5,5.906,5c2.96,0,5.429-2.172,5.909-5H45h1h1c1.66,0,3-1.34,3-3v-9.625C50,23.086,48.406,21.063,48.406,21.063z M44.344,19l2.438,3.25c0,0,0.906,1.551,1.094,2.75H38c-0.168,0-0.438-0.125-0.656-0.344S37,24.168,37,24v-4c0-0.504,0.594-1,1-1H44.344z M25,27H15V17h10V27z M10,5h10v10h-4h-2h-4V5z M5,17h4h4v10H5V17z M14,41c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S16.206,41,14,41z M39,41c-2.223,0-4-1.777-4-4s1.777-4,4-4s4,1.777,4,4S41.223,41,39,41z M48,35c0,0.375-0.625,1-1,1h-1h-1h-0.091c-0.48-2.828-2.95-5-5.909-5c-2.965,0-5.43,2.164-5.906,5H33H19.91c-0.478-2.833-2.942-5-5.91-5s-5.431,2.167-5.91,5H4c-1.103,0-2-0.897-2-2v-5h2h10h2h10h4c0.552,0,1-0.448,1-1v-2.05V24v-8c0-0.375,0.625-1,1-1h8c0.785,0,1.891,0.84,2.656,1.75c0.008,0.012,0.023,0.02,0.031,0.031L42.844,17H38c-1.594,0-3,1.289-3,3v4c0,0.832,0.375,1.563,0.906,2.094S37.168,27,38,27h10V35z"/>
                                        </svg>
                                    </div>
                                </div>
                                {claimForm.transportId !== 3 && (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "flex-start",
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: ".3rem 1rem 0 1rem",
                                                fontWeight: "600",
                                            }}
                                        >
                                            Gate out date
                                            <span
                                                style={{
                                                    paddingLeft: ".5rem",
                                                    fontWeight: "400",
                                                    color: "#a1a1a1",
                                                }}
                                            >
                        | {claimForm.gateOutDate || "No Gate out date"}
                      </span>
                                        </div>
                                        <div
                                            style={{
                                                padding: "0 1rem 0 1rem",
                                                fontWeight: "400",
                                                color: "#a1a1a1",
                                            }}
                                        >
                                            {/*Shangai - China*/}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "70px",
                                    height: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "3px",
                                        height: "10px",
                                        border: "2px solid #68dbc9",
                                        marginLeft: "35px",
                                        backgroundColor: "#68dbc9",
                                    }}
                                ></div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "400px",
                                    height: "70px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70px",
                                        height: "70px",
                                        border: "2px solid #68dbc9",
                                        borderRadius: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.0"
                                            width="50px"
                                            height="50px"
                                            viewBox="0 0 900.000000 1008.000000"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <link
                                                xmlns=""
                                                type="text/css"
                                                rel="stylesheet"
                                                id="dark-mode-custom-link"
                                            />
                                            <link
                                                xmlns=""
                                                type="text/css"
                                                rel="stylesheet"
                                                id="dark-mode-general-link"
                                            />
                                            <style
                                                xmlns=""
                                                lang="en"
                                                type="text/css"
                                                id="dark-mode-custom-style"
                                            />
                                            <style
                                                xmlns=""
                                                lang="en"
                                                type="text/css"
                                                id="dark-mode-native-style"
                                            />
                                            <style
                                                xmlns=""
                                                lang="en"
                                                type="text/css"
                                                id="dark-mode-native-sheet"
                                            />

                                            <g
                                                transform="translate(0.000000,1008.000000) scale(0.100000,-0.100000)"
                                                fill="#000000"
                                                stroke="none"
                                            >
                                                <path
                                                    d="M2375 9543 c-33 -8 -73 -21 -88 -29 -16 -8 -32 -14 -37 -14 -23 0 -138 -80 -190 -131 -65 -64 -99 -113 -144 -204 -50 -104 -59 -154 -65 -380 l-6 -210 -270 -6 c-263 -5 -334 -13 -415 -47 -14 -5 -45 -18 -70 -28 -207 -85 -406 -268 -519 -478 -44 -81 -87 -199 -104 -286 -16 -84 -22 -6217 -6 -6330 16 -113 56 -237 110 -336 129 -238 369 -437 619 -513 155 -47 6 -45 3290 -48 2069 -2 3113 0 3130 7 14 5 52 14 85 19 33 5 76 14 95 21 173 63 291 133 408 244 66 63 162 175 162 190 0 3 13 24 28 48 40 61 66 122 102 233 40 125 40 63 40 3269 0 2126 -3 3099 -11 3145 -26 164 -76 291 -168 430 -52 79 -158 193 -233 252 -41 33 -186 119 -200 119 -5 0 -22 6 -36 14 -56 29 -104 46 -126 46 -13 0 -43 7 -66 15 -32 11 -91 15 -249 15 -113 0 -211 4 -218 8 -8 5 -13 60 -17 177 -4 178 -15 276 -36 335 -100 283 -357 471 -643 470 -68 0 -192 -26 -233 -49 -11 -5 -39 -19 -64 -30 -105 -48 -227 -173 -288 -296 -59 -117 -65 -151 -69 -380 -3 -127 -8 -214 -15 -222 -15 -19 -627 -19 -650 0 -14 10 -17 44 -21 232 -3 197 -6 226 -26 280 -47 126 -104 213 -194 295 -49 44 -149 110 -168 110 -6 0 -20 6 -32 12 -39 22 -130 40 -223 45 -130 6 -252 -27 -369 -102 -52 -34 -195 -170 -195 -186 0 -4 -13 -27 -28 -51 -15 -24 -33 -59 -41 -78 -40 -109 -44 -138 -50 -350 l-6 -215 -310 -3 c-170 -1 -320 0 -332 3 -23 5 -23 7 -23 178 0 227 -18 327 -83 447 -143 267 -454 412 -732 343z m254 -393 c85 -43 134 -102 164 -199 15 -48 17 -119 17 -691 0 -606 -1 -640 -20 -694 -36 -105 -106 -176 -198 -201 -26 -7 -51 -14 -57 -16 -19 -6 -119 22 -151 41 -42 27 -98 89 -124 139 -20 39 -20 55 -20 729 0 660 1 691 19 733 28 62 85 126 140 154 61 32 173 35 230 5z m2004 2 c89 -48 132 -100 166 -197 20 -58 21 -77 21 -692 0 -541 -2 -639 -15 -680 -41 -127 -115 -200 -225 -224 -116 -25 -238 37 -301 154 l-34 62 0 690 c0 659 1 692 19 725 40 73 82 120 136 149 47 26 66 31 128 31 51 0 82 -5 105 -18z m2005 1 c85 -39 136 -96 167 -185 21 -62 22 -1342 1 -1403 -28 -78 -73 -137 -137 -177 -46 -29 -141 -44 -191 -29 -89 26 -150 77 -203 171 -19 34 -20 53 -20 725 0 660 1 693 19 735 25 57 100 137 151 161 52 24 163 25 213 2z m1257 -4908 c-1 -1923 -4 -2773 -12 -2802 -15 -63 -71 -149 -128 -200 -52 -46 -96 -69 -180 -97 -46 -15 -301 -16 -3100 -14 -2557 3 -3056 5 -3085 17 -69 27 -106 46 -145 76 -49 37 -65 56 -104 121 -65 107 -61 -109 -61 2908 0 1508 3 2746 7 2749 3 4 1537 6 3407 5 l3401 -3 0 -2760z"/>
                                                <path
                                                    d="M1634 5918 c-5 -7 -8 -235 -9 -506 0 -457 1 -494 17 -503 10 -5 249 -8 575 -7 l558 3 0 510 0 510 -567 3 c-441 2 -568 -1 -574 -10z"/>
                                                <path
                                                    d="M3163 5923 c-10 -4 -13 -115 -13 -508 0 -449 2 -504 16 -509 9 -3 264 -6 569 -6 454 0 555 2 564 14 8 9 10 152 9 512 l-3 499 -565 2 c-311 1 -571 -1 -577 -4z"/>
                                                <path
                                                    d="M4677 5923 c-4 -3 -7 -230 -7 -503 0 -372 3 -499 12 -508 9 -9 148 -12 564 -12 304 0 559 3 568 6 14 5 16 60 16 509 0 449 -2 504 -16 509 -21 8 -1129 8 -1137 -1z"/>
                                                <path
                                                    d="M6205 5918 c-3 -7 -4 -238 -3 -513 l3 -500 558 -3 c325 -1 565 2 575 7 16 9 17 46 17 503 -1 271 -4 499 -9 506 -11 18 -1134 18 -1141 0z"/>
                                                <path
                                                    d="M1633 4558 c-9 -16 -11 -974 -2 -990 6 -10 598 -15 1067 -9 l82 1 -2 503 -3 502 -567 3 c-447 2 -568 0 -575 -10z"/>
                                                <path
                                                    d="M3157 4563 c-4 -3 -7 -231 -7 -505 0 -467 1 -498 18 -499 81 -5 1123 0 1131 5 12 8 16 960 5 990 -6 14 -65 16 -573 16 -312 0 -571 -3 -574 -7z"/>
                                                <path
                                                    d="M4676 4554 c-12 -30 -7 -982 5 -990 12 -7 1101 -13 1132 -6 16 4 17 34 15 506 l-3 501 -571 3 c-515 2 -572 1 -578 -14z"/>
                                                <path
                                                    d="M6207 4563 c-10 -9 -9 -1003 1 -1004 4 0 260 -1 570 -2 417 0 565 2 571 11 9 15 7 974 -2 990 -6 9 -132 12 -571 12 -309 0 -566 -3 -569 -7z"/>
                                                <path
                                                    d="M1642 3214 c-13 -9 -15 -78 -16 -503 -1 -354 2 -495 10 -502 7 -5 237 -8 575 -7 l564 3 0 505 0 505 -559 5 c-398 4 -563 2 -574 -6z"/>
                                                <path
                                                    d="M6760 3220 l-555 -5 0 -505 0 -505 559 -5 c407 -4 563 -2 575 6 14 10 16 60 15 495 -1 266 -2 489 -3 496 -1 7 -9 16 -18 20 -10 4 -268 6 -573 3z"/>
                                                <path
                                                    d="M3155 3208 c-3 -7 -4 -236 -3 -508 l3 -495 575 0 575 0 3 485 c1 267 0 495 -3 508 l-5 22 -571 0 c-446 0 -571 -3 -574 -12z"/>
                                                <path
                                                    d="M4675 3198 c-3 -13 -4 -241 -3 -508 l3 -485 575 0 575 0 0 505 0 505 -572 3 -573 2 -5 -22z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{padding: ".3rem 1rem 0 1rem", fontWeight: "600"}}
                                    >
                                        ETD
                                        <span
                                            style={{
                                                paddingLeft: ".5rem",
                                                fontWeight: "400",
                                                color: "#a1a1a1",
                                            }}
                                        >
                      | {claimForm.cargo.etd || "No ETD"}
                    </span>
                                    </div>
                                    {/*<div style={{padding:'0 1rem 0 1rem', fontWeight:'400', color:'#a1a1a1'}}>*/}
                                    {/*    Shangai - China*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "70px",
                                    height: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "3px",
                                        height: "10px",
                                        border: "2px solid #68dbc9",
                                        marginLeft: "35px",
                                        backgroundColor: "#68dbc9",
                                    }}
                                ></div>
                            </div>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "start",
                                    width: "400px",
                                    height: "70px",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        width: "70px",
                                        height: "70px",
                                        border: "2px solid #68dbc9",
                                        borderRadius: "100%",
                                    }}
                                >
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                        }}
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            version="1.0"
                                            width="50px"
                                            height="50px"
                                            viewBox="0 0 900.000000 1008.000000"
                                            preserveAspectRatio="xMidYMid meet"
                                        >
                                            <link
                                                xmlns=""
                                                type="text/css"
                                                rel="stylesheet"
                                                id="dark-mode-custom-link"
                                            />
                                            <link
                                                xmlns=""
                                                type="text/css"
                                                rel="stylesheet"
                                                id="dark-mode-general-link"
                                            />
                                            <style
                                                xmlns=""
                                                lang="en"
                                                type="text/css"
                                                id="dark-mode-custom-style"
                                            />
                                            <style
                                                xmlns=""
                                                lang="en"
                                                type="text/css"
                                                id="dark-mode-native-style"
                                            />
                                            <style
                                                xmlns=""
                                                lang="en"
                                                type="text/css"
                                                id="dark-mode-native-sheet"
                                            />

                                            <g
                                                transform="translate(0.000000,1008.000000) scale(0.100000,-0.100000)"
                                                fill="#000000"
                                                stroke="none"
                                            >
                                                <path
                                                    d="M2375 9543 c-33 -8 -73 -21 -88 -29 -16 -8 -32 -14 -37 -14 -23 0 -138 -80 -190 -131 -65 -64 -99 -113 -144 -204 -50 -104 -59 -154 -65 -380 l-6 -210 -270 -6 c-263 -5 -334 -13 -415 -47 -14 -5 -45 -18 -70 -28 -207 -85 -406 -268 -519 -478 -44 -81 -87 -199 -104 -286 -16 -84 -22 -6217 -6 -6330 16 -113 56 -237 110 -336 129 -238 369 -437 619 -513 155 -47 6 -45 3290 -48 2069 -2 3113 0 3130 7 14 5 52 14 85 19 33 5 76 14 95 21 173 63 291 133 408 244 66 63 162 175 162 190 0 3 13 24 28 48 40 61 66 122 102 233 40 125 40 63 40 3269 0 2126 -3 3099 -11 3145 -26 164 -76 291 -168 430 -52 79 -158 193 -233 252 -41 33 -186 119 -200 119 -5 0 -22 6 -36 14 -56 29 -104 46 -126 46 -13 0 -43 7 -66 15 -32 11 -91 15 -249 15 -113 0 -211 4 -218 8 -8 5 -13 60 -17 177 -4 178 -15 276 -36 335 -100 283 -357 471 -643 470 -68 0 -192 -26 -233 -49 -11 -5 -39 -19 -64 -30 -105 -48 -227 -173 -288 -296 -59 -117 -65 -151 -69 -380 -3 -127 -8 -214 -15 -222 -15 -19 -627 -19 -650 0 -14 10 -17 44 -21 232 -3 197 -6 226 -26 280 -47 126 -104 213 -194 295 -49 44 -149 110 -168 110 -6 0 -20 6 -32 12 -39 22 -130 40 -223 45 -130 6 -252 -27 -369 -102 -52 -34 -195 -170 -195 -186 0 -4 -13 -27 -28 -51 -15 -24 -33 -59 -41 -78 -40 -109 -44 -138 -50 -350 l-6 -215 -310 -3 c-170 -1 -320 0 -332 3 -23 5 -23 7 -23 178 0 227 -18 327 -83 447 -143 267 -454 412 -732 343z m254 -393 c85 -43 134 -102 164 -199 15 -48 17 -119 17 -691 0 -606 -1 -640 -20 -694 -36 -105 -106 -176 -198 -201 -26 -7 -51 -14 -57 -16 -19 -6 -119 22 -151 41 -42 27 -98 89 -124 139 -20 39 -20 55 -20 729 0 660 1 691 19 733 28 62 85 126 140 154 61 32 173 35 230 5z m2004 2 c89 -48 132 -100 166 -197 20 -58 21 -77 21 -692 0 -541 -2 -639 -15 -680 -41 -127 -115 -200 -225 -224 -116 -25 -238 37 -301 154 l-34 62 0 690 c0 659 1 692 19 725 40 73 82 120 136 149 47 26 66 31 128 31 51 0 82 -5 105 -18z m2005 1 c85 -39 136 -96 167 -185 21 -62 22 -1342 1 -1403 -28 -78 -73 -137 -137 -177 -46 -29 -141 -44 -191 -29 -89 26 -150 77 -203 171 -19 34 -20 53 -20 725 0 660 1 693 19 735 25 57 100 137 151 161 52 24 163 25 213 2z m1257 -4908 c-1 -1923 -4 -2773 -12 -2802 -15 -63 -71 -149 -128 -200 -52 -46 -96 -69 -180 -97 -46 -15 -301 -16 -3100 -14 -2557 3 -3056 5 -3085 17 -69 27 -106 46 -145 76 -49 37 -65 56 -104 121 -65 107 -61 -109 -61 2908 0 1508 3 2746 7 2749 3 4 1537 6 3407 5 l3401 -3 0 -2760z"/>
                                                <path
                                                    d="M1634 5918 c-5 -7 -8 -235 -9 -506 0 -457 1 -494 17 -503 10 -5 249 -8 575 -7 l558 3 0 510 0 510 -567 3 c-441 2 -568 -1 -574 -10z"/>
                                                <path
                                                    d="M3163 5923 c-10 -4 -13 -115 -13 -508 0 -449 2 -504 16 -509 9 -3 264 -6 569 -6 454 0 555 2 564 14 8 9 10 152 9 512 l-3 499 -565 2 c-311 1 -571 -1 -577 -4z"/>
                                                <path
                                                    d="M4677 5923 c-4 -3 -7 -230 -7 -503 0 -372 3 -499 12 -508 9 -9 148 -12 564 -12 304 0 559 3 568 6 14 5 16 60 16 509 0 449 -2 504 -16 509 -21 8 -1129 8 -1137 -1z"/>
                                                <path
                                                    d="M6205 5918 c-3 -7 -4 -238 -3 -513 l3 -500 558 -3 c325 -1 565 2 575 7 16 9 17 46 17 503 -1 271 -4 499 -9 506 -11 18 -1134 18 -1141 0z"/>
                                                <path
                                                    d="M1633 4558 c-9 -16 -11 -974 -2 -990 6 -10 598 -15 1067 -9 l82 1 -2 503 -3 502 -567 3 c-447 2 -568 0 -575 -10z"/>
                                                <path
                                                    d="M3157 4563 c-4 -3 -7 -231 -7 -505 0 -467 1 -498 18 -499 81 -5 1123 0 1131 5 12 8 16 960 5 990 -6 14 -65 16 -573 16 -312 0 -571 -3 -574 -7z"/>
                                                <path
                                                    d="M4676 4554 c-12 -30 -7 -982 5 -990 12 -7 1101 -13 1132 -6 16 4 17 34 15 506 l-3 501 -571 3 c-515 2 -572 1 -578 -14z"/>
                                                <path
                                                    d="M6207 4563 c-10 -9 -9 -1003 1 -1004 4 0 260 -1 570 -2 417 0 565 2 571 11 9 15 7 974 -2 990 -6 9 -132 12 -571 12 -309 0 -566 -3 -569 -7z"/>
                                                <path
                                                    d="M1642 3214 c-13 -9 -15 -78 -16 -503 -1 -354 2 -495 10 -502 7 -5 237 -8 575 -7 l564 3 0 505 0 505 -559 5 c-398 4 -563 2 -574 -6z"/>
                                                <path
                                                    d="M6760 3220 l-555 -5 0 -505 0 -505 559 -5 c407 -4 563 -2 575 6 14 10 16 60 15 495 -1 266 -2 489 -3 496 -1 7 -9 16 -18 20 -10 4 -268 6 -573 3z"/>
                                                <path
                                                    d="M3155 3208 c-3 -7 -4 -236 -3 -508 l3 -495 575 0 575 0 3 485 c1 267 0 495 -3 508 l-5 22 -571 0 c-446 0 -571 -3 -574 -12z"/>
                                                <path
                                                    d="M4675 3198 c-3 -13 -4 -241 -3 -508 l3 -485 575 0 575 0 0 505 0 505 -572 3 -573 2 -5 -22z"/>
                                            </g>
                                        </svg>
                                    </div>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "flex-start",
                                    }}
                                >
                                    <div
                                        style={{padding: ".3rem 1rem 0 1rem", fontWeight: "600"}}
                                    >
                                        ETA
                                        <span
                                            style={{
                                                paddingLeft: ".5rem",
                                                fontWeight: "400",
                                                color: "#a1a1a1",
                                            }}
                                        >
                      | {claimForm.cargo.eta || "No ETA"}
                    </span>
                                    </div>
                                    {/*<div style={{padding:'0 1rem 0 1rem', fontWeight:'400', color:'#a1a1a1'}}>*/}
                                    {/*    Shangai - China*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    padding: "1rem 1rem 0 1rem",
                    width: "33ch",
                    margin: "auto",
                }}
            >
                <div style={{marginTop: "1rem", width: "100%"}}>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        {claimForm.transportId === 1 ? (
                            <div style={{fontWeight: 500}}>Delay in overseas transit</div>
                        ) : (
                            <div style={{fontWeight: 500}}>Delay in transit</div>
                        )}

                        <div>
                            {!(claimForm?.ata === "" || claimForm?.ata === null) &&
                            !(claimForm?.blAwbDate === "" || claimForm?.blAwbDate === null)
                                ? claimForm?.cargo?.eta
                                    ? `${dateDiffInDays(
                                        claimForm?.ata,
                                        claimForm?.cargo?.eta
                                    )} days`
                                    : " No ETA"
                                : "Unkwown"}
                        </div>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <div style={{fontWeight: 500}}>Total transportation time</div>
                        <div>
                            {!(
                                claimForm?.gateOutDate === "" || claimForm?.gateOutDate === null
                            ) &&
                            !(claimForm?.blAwbDate === "" || claimForm?.blAwbDate === null)
                                ? `${dateDiffInDays(
                                    claimForm?.gateOutDate,
                                    claimForm?.blAwbDate
                                )} days`
                                : "Unkwown"}
                        </div>
                    </div>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <div style={{fontWeight: 500}}>Age of the fruit</div>
                        <div>
                            {!(surveyDate === "" || surveyDate === null) &&
                            !(fechaHar === "" || fechaHar === null || fechaHar === "Unknown")
                                ? `${dateDiffInDays(surveyDate, fechaHar)} days`
                                : "Unkwown"}
                        </div>
                    </div>
                    <div style={{position: "relative"}}>
                        <div
                            style={{
                                position: "absolute",
                                top: "-18px",
                                left: "53px",
                                transform: "translateX(-50%)",
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.0"
                                width="400px"
                                height="30px"
                                viewBox="0 0 900.000000 171.000000"
                                preserveAspectRatio="xMidYMid meet"
                            >
                                <g
                                    transform="translate(0.000000,171.000000) scale(0.100000,-0.100000)"
                                    fill="#000000"
                                    stroke="none"
                                >
                                    <path
                                        d="M769 1382 c-42 -25 -89 -102 -89 -145 0 -49 31 -109 73 -141 36 -28 102 -36 164 -22 32 7 37 3 309 -268 l276 -276 3565 0 3564 0 -3 28 -3 27 -3555 3 -3555 2 -263 263 -262 262 19 52 c32 88 -1 177 -81 219 -35 18 -126 16 -159 -4z"/>
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            {claimForm.inspection.inspectionReport.inspectionFruit.length !== 0 && (
                <div style={{marginTop: "5rem", marginBottom: "2rem"}}>
                    <b>EXTENT OF DAMAGE</b>
                    <div style={{height: "20px"}}></div>

                    <p>
                        Based on the survey findings we can conclude that the cargo was
                        found with the following issues
                    </p>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            padding: "1rem 1rem 2rem 1rem",
                            fontSize: "1rem",
                        }}
                    >
                        <table style={{border: "3px solid #e1e1e1"}}>
                            <tr style={{backgroundColor: "#1c36af", color: "white"}}>
                                <th
                                    style={{
                                        backgroundColor: "#1c36af",
                                        color: "white",
                                        padding: ".4rem .4rem",
                                        border: "3px solid #e1e1e1",
                                        textAlign: "center",
                                        fontSize: "1rem",
                                    }}
                                >
                                    Pallet Number
                                </th>
                                <th
                                    style={{
                                        backgroundColor: "#1c36af",
                                        color: "white",
                                        padding: ".4rem .4rem",
                                        border: "3px solid #e1e1e1",
                                        textAlign: "center",
                                        fontSize: "1rem",
                                    }}
                                >
                                    Box Label
                                </th>
                                <th
                                    style={{
                                        backgroundColor: "#1c36af",
                                        color: "white",
                                        padding: ".4rem .4rem",
                                        border: "3px solid #e1e1e1",
                                        textAlign: "center",
                                        fontSize: "1rem",
                                    }}
                                >
                                    Variety
                                </th>
                                {/*<th style={{backgroundColor:"#1c36af", color:'white',padding:'.4rem 1rem',border:'3px solid #e1e1e1',textAlign:'center'}}>Box Location</th>*/}
                                {columnasTabla.map((columna, index) => {
                                    return (
                                        <th
                                            style={{
                                                backgroundColor: "#1c36af",
                                                color: "white",
                                                padding: ".4rem 1rem",
                                                border: "3px solid #e1e1e1",
                                                textAlign: "center",
                                                fontSize: ".9rem",
                                            }}
                                            key={columna}
                                        >
                                            {columna}
                                        </th>
                                    );
                                })}
                            </tr>

                            {allPalletsDamage.boxes.map((pallet, index) => {
                                return (
                                    <tr key={index} style={{border: "3px solid #e1e1e1"}}>
                                        <td
                                            style={{
                                                border: "3px solid #e1e1e1",
                                                padding: ".4rem .4rem",
                                                textAlign: "center",
                                                minWidth: "5ch",
                                                fontSize: "1rem",
                                            }}
                                        >
                                            {pallet.palletNumber}
                                        </td>
                                        <td
                                            style={{
                                                border: "3px solid #e1e1e1",
                                                padding: ".4rem .4rem",
                                                textAlign: "center",
                                                minWidth: "5ch",
                                                fontSize: "1rem",
                                            }}
                                        >
                                            {pallet.boxLabel}
                                        </td>
                                        <td
                                            style={{
                                                border: "3px solid #e1e1e1",
                                                padding: ".4rem .4rem",
                                                textAlign: "center",
                                                minWidth: "5ch",
                                                fontSize: "1rem",
                                            }}
                                        >
                                            {pallet.variety}
                                        </td>
                                        {/*<td style={{border:'3px solid #e1e1e1',padding:'.4rem 1rem', textAlign:'center', minWidth:'13ch'}}>{pallet.boxLocation}</td>*/}
                                        {listoParalaTabla.map((fila, index2) => (
                                            <>
                                                {fila[0].length !== 0 &&
                                                    fila.map((columna, idx) => {
                                                        return (
                                                            index === index2 && (
                                                                <td
                                                                    key={idx}
                                                                    style={{
                                                                        border: "3px solid #e1e1e1",
                                                                        padding: ".4rem .4rem",
                                                                        textAlign: "center",
                                                                        minWidth: "5ch",
                                                                        fontSize: "1rem",
                                                                    }}
                                                                >
                                                                    {columna.percentage !== undefined &&
                                                                        `${columna.percentage.toFixed(2)}%`}
                                                                </td>
                                                            )
                                                        );
                                                    })}
                                            </>
                                        ))}
                                    </tr>
                                );
                            })}
                            <tr>
                                <td
                                    colSpan={3}
                                    style={{
                                        border: "3px solid #e1e1e1",
                                        backgroundColor: "#e1e1e1",
                                        fontWeight: "bolder",
                                        padding: ".4rem 1rem",
                                        textAlign: "center",
                                        minWidth: "13ch",
                                    }}
                                >
                                    AVERAGE DAMAGE
                                </td>
                                {listoParalaTabla.map((fila, idx) => {
                                    if (idx === listoParalaTabla.length - 1) {
                                        return fila[0].map((e, idx) => (
                                            <td
                                                key={idx}
                                                style={{
                                                    border: "3px solid #e1e1e1",
                                                    padding: ".4rem .4rem",
                                                    textAlign: "center",
                                                    minWidth: "10ch",
                                                    fontSize: "1rem",
                                                }}
                                            >
                                                {e.percentage.toFixed(2)}%
                                            </td>
                                        ));
                                    }
                                })}
                            </tr>
                        </table>
                    </div>
                </div>
            )}
            {claimForm.inspection.inspectionReport.inspectionFruit.length === 0 && (
                <div style={{height: "55px"}}></div>
            )}
            <div style={{height: "20px"}}></div>
            <p>
                This report represents our findings at the time and place of inspection
                stated herein only. The intervention has been carried out to the best of
                our knowledge and ability and our responsibility is limited to the
                exercise of reasonable care.
            </p>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    padding: "20rem 2rem 2rem 2rem",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                        alignItems: "center",
                    }}
                >
                    <div style={{textAlign: "center"}}>
                        {claimForm?.surveyor.firstName} {claimForm?.surveyor.lastName}
                    </div>
                    <div
                        style={{textAlign: "center", fontSize: "1.2rem", fontWeight: 600}}
                    >
                        SURVEYOR'S NAME
                    </div>
                </div>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                        alignItems: "center",
                    }}
                >
                    <div style={{textAlign: "center"}}>
                        {claimForm.inspection.inspectionDate}
                    </div>
                    <div
                        style={{textAlign: "center", fontSize: "1.2rem", fontWeight: 600}}
                    >
                        INSPECTION DATE
                    </div>
                </div>
            </div>

            <p style={{paddingTop: "10rem"}}>
                While every effort has been made to ensure accuracy in respect of the
                observations and opinions expressed in the report, it is provided
                without warranty, and neither{" "}
                {claimForm.surveyor.companySurveyorName
                    ? claimForm.surveyor.companySurveyorName
                    : `${claimForm.surveyor.firstName} ${claimForm.surveyor.lastName}`}{" "}
                nor any of its employees, associated companies or divisions shall in any
                circumstances be liable to any person whatsoever for any act, omission
                of default in connection with this report’s preparation and issuance
                however arising.
            </p>
        </>
    );
};
